import React, { useState, useEffect } from "react";
import axios from "axios";
import { createPortal } from "react-dom";
import { findCustomerByPhone, customerRequestOptions, normalizeCustomerPhoneToLocal, saveCustomerSale, completeCustomerSale } from "../services/customerService";
import "bootstrap/dist/css/bootstrap.min.css";
import "./OrderPage.css";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import ShiftSummaryModal from "../components/order_cpn/ShiftSummaryModal";
import CachedProductSearch from "../components/order_cpn/CachedProductSearch";
import OrderSync from "../components/order_cpn/OrderSync";
import OrderGiftDrinkPicker, { OrderGiftDrinkRows } from "../components/order_cpn/OrderGiftDrinkPicker";
import useOrderGiftDrinks from "../hooks/useOrderGiftDrinks";
import { useCheckout } from "../hooks/useCheckout";
import { getOrderPrintSettings, saveOrderPrintSettings } from "../utils/orderPrintSettings";
import { buildOrderReceiptQR, buildOrderReceiptRows, buildOrderTransferQRCode } from "../utils/orderReceipt";
import {
  lookupBusinessByTaxCode,
  normalizeBusinessTaxCode,
} from "../services/businessLookupService";
import { TRUNG_THU_LOAI_BANH } from "../constants/trungThu";
import {
  getAllCachedProducts,
  getCachedCategories,
  getCachedProducts,
  getProductCacheScope,
  saveCategoriesToCache,
  saveProductsToCache,
} from "../services/posProductCache";
import jsQR from "jsqr";
import BreadAddonModal from "../desktop/BreadAddonModal";
import { applyBreadAddons, isBreadWithFilling, mapCatalogProduct } from "../desktop/catalog";
import { isCoarsePointer, preventIOSInputZoom } from "../utils/touchViewport";
import { repriceOrderItems, withChannelPrice } from "../utils/orderChannelPrice";
import { findProductSuggestions, mergeProductSearchResults, sortDesktopProductSearchResults } from "../utils/productSuggestions";

// Custom hook for drag-to-scroll (fix: prevent text selection)
function useDragScroll(ref) {
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let isDown = false;
    let startX, scrollLeft;

    const mouseDownHandler = (e) => {
      isDown = true;
      el.classList.add("dragging");
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      // Prevent text selection while dragging
      // document.body.style.userSelect = "none"; // Removed
    };
    const mouseLeaveHandler = () => {
      isDown = false;
      el.classList.remove("dragging");
      // document.body.style.userSelect = ""; // Removed
    };
    const mouseUpHandler = () => {
      isDown = false;
      el.classList.remove("dragging");
      // document.body.style.userSelect = ""; // Removed
    };
    const mouseMoveHandler = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    };

    el.addEventListener("mousedown", mouseDownHandler);
    el.addEventListener("mouseleave", mouseLeaveHandler);
    el.addEventListener("mouseup", mouseUpHandler);
    el.addEventListener("mousemove", mouseMoveHandler);

    // Touch events for mobile
    let touchStartX, touchScrollLeft;
    const touchStartHandler = (e) => {
      isDown = true;
      el.classList.add("dragging");
      touchStartX = e.touches[0].pageX - el.offsetLeft;
      touchScrollLeft = el.scrollLeft;
    };
    const touchEndHandler = () => {
      isDown = false;
      el.classList.remove("dragging");
    };
    const touchMoveHandler = (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - el.offsetLeft;
      const walk = (x - touchStartX) * 1.5;
      el.scrollLeft = touchScrollLeft - walk;
    };

    el.addEventListener("touchstart", touchStartHandler);
    el.addEventListener("touchend", touchEndHandler);
    el.addEventListener("touchmove", touchMoveHandler);

    return () => {
      el.removeEventListener("mousedown", mouseDownHandler);
      el.removeEventListener("mouseleave", mouseLeaveHandler);
      el.removeEventListener("mouseup", mouseUpHandler);
      el.removeEventListener("mousemove", mouseMoveHandler);
      el.removeEventListener("touchstart", touchStartHandler);
      el.removeEventListener("touchend", touchEndHandler);
      el.removeEventListener("touchmove", touchMoveHandler);
      // document.body.style.userSelect = ""; // Removed
    };
  }, [ref]);
}

// Hàm lấy đường dẫn ảnh theo mã category
const getCategoryImage = (categoryId) => {
  switch (categoryId) {
    case "BANHBAO":
      return "/banhbao.png";
    case "BANHKHO":
      return "/bread.png";
    case "BANHLANH":
      return "/tiramisu.png";
    case "BANHMAN":
      return "/pizza.png";
    case "BMCN":
      return "/bmcn.png";
    case "BMKN":
      return "/bread.png";
    case "BANHNGOT":
      return "/banhngot.png";
    case "CAFE":
      return "/nuoc.png";
    case "BANHBLL":
      return "/nuoc.png";
    case "BANHBLN":
      return "/bonglan.png";
    case "KEM":
      return "/kem.png";
    case "TH":
      return "/taphoa.png";
    default:
      return "/bread.png";
  }
};

const mapUnitToVietnamese = (unit) => {
  if (!unit) return "";

  const unitMap = {
    // Các đơn vị chuẩn
    miếng: "mieng",
    phần: "phan",
    cái: "cai",
    hộp: "hop",
    gói: "goi",

    // Các trường hợp lỗi font hoặc encoding
    "mi?ng": "mieng",
    "ph?n": "phan",
    "c�i": "cai",
    "h?p": "hop",
    "g�i": "goi",
    "l�t": "lit",

    // Các biến thể viết hoa
    MIẾNG: "mieng",
    PHẦN: "phan",
    CÁI: "cai",
    HỘP: "hop",
  };

  // Tìm trong map, nếu không có thì giữ nguyên
  const lowerUnit = unit.toLowerCase().trim();
  return unitMap[lowerUnit] || unit;
};

const LOCAL_SEARCH_LIMIT = 60;
const POS_API_BASE_URL = (
  process.env.REACT_APP_POS_API_BASE_URL || "https://doticom.vn:3000"
).replace(/\/+$/, "");
const MONTHLY_REVENUE_API_BASE_URL = (
  process.env.REACT_APP_MONTHLY_REVENUE_API_BASE_URL || "https://doticom.vn:3000"
).replace(/\/+$/, "");
const DEFAULT_PRINT_HOST = process.env.REACT_APP_PRINT_HOST || "doticom.vn";
const UPDATE_TAX_INFO_AFTER_PRINT_FAILURE_URL = process.env.REACT_UPDATE_TAX_HOST||
  "https://pos.doanquochoa.name.vn/api/updateTaxInfo";
const DEFAULT_LOAI_BANH = 0;
const TRUNG_THU_PRODUCT_GROUP_CODES = new Set([
  "0002",
  "0003",
  "0004",
  "0005",
  "0006",
  "0007",
  "0008",
  "0009",
  "0010",
  "0011",
  "0012",
]);

const normalizeProductGroupCode = (value) => {
  const groupCode = String(value ?? "").trim();
  return /^\d{1,4}$/.test(groupCode) ? groupCode.padStart(4, "0") : groupCode;
};

const getProductLoaiBanh = (product) => {
  const groupCode = normalizeProductGroupCode(
    product?.MaNLSP ?? product?.categoryId ?? product?.category,
  );

  return Number(product?.LoaiBanh) === TRUNG_THU_LOAI_BANH ||
    TRUNG_THU_PRODUCT_GROUP_CODES.has(groupCode)
    ? TRUNG_THU_LOAI_BANH
    : DEFAULT_LOAI_BANH;
};

const getBillLoaiBanh = (items) =>
  items.some(
    (item) => getProductLoaiBanh(item) === TRUNG_THU_LOAI_BANH,
  )
    ? TRUNG_THU_LOAI_BANH
    : DEFAULT_LOAI_BANH;

const getCurrentMonthInputValue = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
};

const MONTH_SELECT_OPTIONS = Array.from({ length: 12 }, (_, index) =>
  String(index + 1).padStart(2, "0"),
);

const getMonthInputParts = (value) => {
  const now = new Date();
  const [year, month] = String(value || "").split("-");

  return {
    year: year || String(now.getFullYear()),
    month: month || String(now.getMonth() + 1).padStart(2, "0"),
  };
};

const getCategoriesApiUrl = (storeName) => {
  const baseApiUrl = `${POS_API_BASE_URL}/categories`;

  if (storeName === "dongtien" || !storeName) return baseApiUrl;
  if (storeName === "bonpas") return `${baseApiUrl}-bonpas`;
  if (storeName === "hcm") return `${baseApiUrl}-hcm`;
  return `${baseApiUrl}-${storeName}`;
};

const mapCategories = (items) =>
  items.map((category) => ({
    id: category.MaNLSP,
    name: category.TenLoaiSP,
    image: getCategoryImage(category.MaNLSP),
  }));

const areProductsEqual = (currentProducts = [], nextProducts = []) =>
  currentProducts.length === nextProducts.length &&
  currentProducts.every((product, index) => {
    const nextProduct = nextProducts[index];
    return (
      product.id === nextProduct.id &&
      product.name === nextProduct.name &&
      product.price === nextProduct.price &&
      product.price2 === nextProduct.price2 &&
      product.unit === nextProduct.unit &&
      product.vat === nextProduct.vat &&
      product.category === nextProduct.category
    );
  });

function OrderPage() {
  const [showShiftSummary, setShowShiftSummary] = useState(false);
  const [shiftSummaryData, setShiftSummaryData] = useState(null);
  const [showMonthlyRevenue, setShowMonthlyRevenue] = useState(false);
  const [monthlyRevenueData, setMonthlyRevenueData] = useState(null);
  const [monthlyRevenueMonth, setMonthlyRevenueMonth] = useState(
    getCurrentMonthInputValue,
  );
  const [monthlyRevenueLoading, setMonthlyRevenueLoading] = useState(false);
  const monthlyRevenueDateParts = getMonthInputParts(monthlyRevenueMonth);

  const [showPrintSettings, setShowPrintSettings] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [qrManualInput, setQrManualInput] = useState("");
  const [qrProcessing, setQrProcessing] = useState(false);
  const [qrCameraError, setQrCameraError] = useState("");
  const qrVideoRef = React.useRef(null);
  const qrCanvasRef = React.useRef(null);
  const qrScanIntervalRef = React.useRef(null);
  const qrCameraStreamRef = React.useRef(null);
  const qrCameraStartTimeoutRef = React.useRef(null);
  // State
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [productsRefreshing, setProductsRefreshing] = useState(false);
  const [productsSource, setProductsSource] = useState(null);
  const [productsSyncError, setProductsSyncError] = useState("");
  const [lastProductsSync, setLastProductsSync] = useState(null);
  const [productsRefreshKey, setProductsRefreshKey] = useState(0);
  const productRequestIdRef = React.useRef(0);
  const [orderItems, setOrderItems] = useState([]);
  const [addonItem, setAddonItem] = useState(null);
  useEffect(() => {
    if (!orderItems.some((item) => item._addonParent && !orderItems.some((parent) => String(parent._uniqueId || parent.id) === String(item._addonParent)))) return;
    setOrderItems((items) => items.filter((item) => !item._addonParent || items.some((parent) => String(parent._uniqueId || parent.id) === String(item._addonParent))));
  }, [orderItems]);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [cashDiscount, setCashDiscount] = useState(0);
  const [loading, setLoading] = useState({
    categories: true,
    products: false,
    search: false, // Add new loading state for search
  });
  const [showCartModal, setShowCartModal] = useState(false);

  // Add search-related state variables
  const [searchTerm, setSearchTerm] = useState("");
  const [submittedSearchTerm, setSubmittedSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchMode, setIsSearchMode] = useState(false);

  // Add Grab & Foody toggle state
  const [isGrabFoodyMode, setIsGrabFoodyMode] = useState(false);

  // Toggling Grab & Foody switches every cart line between DonGia and DonGia2,
  // so the cart and checkout totals follow the active channel.
  useEffect(() => {
    setOrderItems((items) => repriceOrderItems(items, isGrabFoodyMode));
  }, [isGrabFoodyMode]);

  // Thêm state cho khách hàng
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerSearchType, setCustomerSearchType] = useState("phone");
  const [businessPhone, setBusinessPhone] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [verifiedBusinessTaxCode, setVerifiedBusinessTaxCode] = useState("");
  const businessLookupRequestRef = React.useRef(0);
  const customerSearchId = React.useRef(0);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [newCustomerName, setNewCustomerName] = useState("");
  const [newCustomerAddress, setNewCustomerAddress] = useState("");
  const [newCustomerTaxCode, setNewCustomerTaxCode] = useState("");
  const [customerLoading, setCustomerLoading] = useState(false);

  // Thêm state cho điểm tiêu
  const [usePoint, setUsePoint] = useState("");

  // Add debug state
  const [debug, setDebug] = useState({
    categoriesResponse: null,
    error: null,
  });

  // State cho voucher
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherInfo, setVoucherInfo] = useState(null);
  const [voucherError, setVoucherError] = useState("");
  const [voucherDiscount, setVoucherDiscount] = useState(0);
  const voucherLookupRequest = React.useRef(0);
  useEffect(() => {
    voucherLookupRequest.current += 1;
    setVoucherInfo(null);
    setVoucherDiscount(0);
    setVoucherError("");
  }, [customerInfo?.MaKH]);

  // State for payment method
  const [paymentMethod, setPaymentMethod] = useState(null);
  const paymentMethodRef = React.useRef(paymentMethod);
  // Thêm state cho chọn bàn nếu LoaiCH === "0"
  const [selectedTable, setSelectedTable] = useState(null);
  const [tablePage, setTablePage] = useState(0);
  const TABLES_PER_PAGE = 10;
  const TOTAL_TABLES = 50;
  const totalTablePages = Math.ceil(TOTAL_TABLES / TABLES_PER_PAGE);

  // State cho ghi chú bill
  const [billNote, setBillNote] = useState("");

  // State cho toggle in hóa đơn
  const [isPrintEnabled, setIsPrintEnabled] = useState(() => getOrderPrintSettings().isPrintEnabled);

  // State cho toggle disable print API
  const [isDisablePrintAPI, setIsDisablePrintAPI] = useState(() => getOrderPrintSettings().isDisablePrintAPI);

  const { isProcessing, runCheckout } = useCheckout();
  const handleCheckoutSafeRef = React.useRef(null);

  const navigate = useNavigate();
  const { storeName } = useParams(); // Get storeName from URL params
  const productCacheScope = React.useMemo(
    () =>
      getProductCacheScope({
        storeName,
        storeId: localStorage.getItem("IDCH"),
        storeType: localStorage.getItem("LoaiCH"),
      }),
    [storeName],
  );

  const [shipperPaymentMethod, setShipperPaymentMethod] = useState("transfer"); // Default to transfer
  const [isTouchDevice] = useState(() => isCoarsePointer());

  useEffect(() => {
    paymentMethodRef.current = paymentMethod;
  }, [paymentMethod]);

  // Effect to disable text selection on the entire page
  useEffect(() => {
    const originalUserSelect = document.body.style.userSelect;
    const originalWebkitUserSelect = document.body.style.webkitUserSelect;
    const originalMozUserSelect = document.body.style.mozUserSelect;
    const originalMsUserSelect = document.body.style.msUserSelect;

    document.body.style.userSelect = "none";
    document.body.classList.add("pos-order-page-active");
    document.body.style.webkitUserSelect = "none";
    document.body.style.mozUserSelect = "none";
    document.body.style.msUserSelect = "none";
    const restoreViewport = preventIOSInputZoom();

    return () => {
      restoreViewport();
      document.body.classList.remove("pos-order-page-active");
      document.body.style.userSelect = originalUserSelect;
      document.body.style.webkitUserSelect = originalWebkitUserSelect;
      document.body.style.mozUserSelect = originalMozUserSelect;
      document.body.style.msUserSelect = originalMsUserSelect;
    };
  }, []); // Empty dependency array ensures this runs only on mount and unmount

  // Authorization check effect
  useEffect(() => {
    const storedLoaiCH = localStorage.getItem("LoaiCH");
    const token = localStorage.getItem("token");

    if (!token) {
      toast.error("Vui lòng đăng nhập để tiếp tục.");
      navigate("/login"); // Redirect to login if no token
      return;
    }

    if (storedLoaiCH === null) {
      toast.error(
        "Không tìm thấy thông tin người dùng. Vui lòng đăng nhập lại.",
      );
      navigate("/login"); // Or handle as an error
      return;
    }

    const loaiCH = parseInt(storedLoaiCH, 10);
    let isAdminHcm = localStorage.getItem("HCM_ADMIN") ? 1 : 0;

    if (storeName === "bonpas" && loaiCH !== 0) {
      navigate("/order"); // Redirect to error page if not authorized
    } else if (storeName === "hcm" && loaiCH !== 3 && isAdminHcm !== 1) {
      navigate("/order");
    } else if (storeName === "dongtien" && loaiCH !== 2 && loaiCH !== 99) {
      navigate("/order");
    }
    // If storeName is neither 'bonpas' nor 'dongtien', or if loaiCH matches, allow access.
    // Additional checks for other storeNames can be added here if necessary.
  }, [navigate, storeName]);

  // Fetch categories when component mounts
  useEffect(() => {
    let isActive = true;

    const applyCategories = (nextCategories) => {
      setCategories(nextCategories);
      setSelectedCategory((currentCategory) =>
        nextCategories.some((category) => category.id === currentCategory)
          ? currentCategory
          : nextCategories[0]?.id || null,
      );
    };

    const initializeCategories = async () => {
      setSelectedCategory(null);
      setCategories([]);
      setLoading((prev) => ({ ...prev, categories: true }));

      try {
        const cachedCategories = await getCachedCategories(productCacheScope);
        if (isActive && cachedCategories) {
          applyCategories(cachedCategories.value);
          setLoading((prev) => ({ ...prev, categories: false }));
        }
      } catch (error) {
        console.warn("Unable to read cached categories:", error);
      }

      try {
        const response = await axios.get(getCategoriesApiUrl(storeName), {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!Array.isArray(response.data) || response.data.length === 0) {
          throw new Error("Categories API returned empty or invalid data");
        }

        const categoriesData = mapCategories(response.data);
        try {
          await saveCategoriesToCache(productCacheScope, categoriesData);
        } catch (error) {
          console.warn("Unable to update categories cache:", error);
        }

        if (isActive) {
          setDebug((prev) => ({ ...prev, categoriesResponse: response.data }));
          applyCategories(categoriesData);
        }
      } catch (error) {
        console.error("Error refreshing categories:", error);
        if (isActive) {
          setDebug((prev) => ({
            ...prev,
            error: error.response
              ? JSON.stringify(error.response.data)
              : error.message,
          }));
        }
      } finally {
        if (isActive) {
          setLoading((prev) => ({ ...prev, categories: false }));
        }
      }
    };

    initializeCategories();
    return () => {
      isActive = false;
    };
  }, [productCacheScope, storeName]);

  // Fetch products when selected category changes
  useEffect(() => {
    let isActive = true;
    const requestId = ++productRequestIdRef.current;
    const isCurrentRequest = () =>
      isActive && requestId === productRequestIdRef.current;

    const fetchProducts = async () => {
      if (!selectedCategory) return;

      let cachedProducts = null;
      try {
        setLoading((prev) => ({ ...prev, products: true }));
        setProductsLoaded(false);
        setProductsRefreshing(false);
        setProductsSource(null);
        setProductsSyncError("");

        const cachedRecord = await getCachedProducts(
          productCacheScope,
          selectedCategory,
        ).catch((error) => {
          console.warn("Unable to read cached products:", error);
          return null;
        });
        if (!isCurrentRequest()) return;

        cachedProducts = cachedRecord?.value || null;
        if (cachedProducts) {
          setProducts((currentProducts) =>
            areProductsEqual(currentProducts[selectedCategory], cachedProducts)
              ? currentProducts
              : { ...currentProducts, [selectedCategory]: cachedProducts },
          );
          setProductsLoaded(true);
          setProductsSource("cache");
          setLastProductsSync(cachedRecord.updatedAt || null);
          setLoading((prev) => ({ ...prev, products: false }));
        }

        setProductsRefreshing(true);

        console.log("Fetching products for category:", selectedCategory);

        const IDCH = localStorage.getItem("IDCH"); // hoặc "idCH" tùy theo bạn lưu
        const MaNLSP = selectedCategory;

        const response = await axios.get(
          `${POS_API_BASE_URL}/api/san-pham?IDCH=${IDCH}&MaNLSP=${MaNLSP}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );

        console.log("Products API response:", response.data);

        if (!response.data || !Array.isArray(response.data)) {
          throw new Error("Products API returned invalid data");
        }

        // Find the current category name from the categories array
        const currentCategoryName =
          categories.find((c) => c.id === selectedCategory)?.name || "Unknown";

        const productsData = response.data.map((item) => ({
          id: item.MaSP,
          name: item.Ten_SP,
          price: item.DonGia || 0,
          price2: item.DonGia2 || item.DonGia || 0, // Add DonGia2 support
          image: getCategoryImage(selectedCategory),
          unit: item.DVT_SP,
          vat: item.VAT_SP,
          category: selectedCategory, // Use category ID (MaNLSP) instead of name
          categoryName: currentCategoryName, // Keep the category name as a separate property if needed
          categoryId: selectedCategory, // Also store the category ID (redundant but kept for backward compatibility)
        }));

        if (!isCurrentRequest()) return;

        if (!areProductsEqual(cachedProducts || [], productsData)) {
          try {
            await saveProductsToCache(
              productCacheScope,
              selectedCategory,
              productsData,
            );
          } catch (error) {
            console.warn("Unable to update product cache:", error);
          }
        }
        if (!isCurrentRequest()) return;

        setProducts((currentProducts) =>
          areProductsEqual(currentProducts[selectedCategory], productsData)
            ? currentProducts
            : { ...currentProducts, [selectedCategory]: productsData },
        );
        setProductsLoaded(true);
        setProductsSource("api");
        setLastProductsSync(new Date().toISOString());
      } catch (error) {
        console.error("Error fetching products:", error);
        console.error("Error details:", error.response || error.message);
        if (isCurrentRequest() && !cachedProducts) {
          setProductsSyncError(
            "Không thể tải danh sách sản phẩm. Vui lòng kiểm tra kết nối mạng.",
          );
        }
      } finally {
        if (isCurrentRequest()) {
          setProductsRefreshing(false);
          setLoading((prev) => ({ ...prev, products: false }));
        }
      }
    };

    fetchProducts();
    return () => {
      isActive = false;
    };
  }, [selectedCategory, productCacheScope, productsRefreshKey]);

  // Helpers: giảm giá theo từng món (KmaiPT)
  const getItemDiscountPercent = (item) => {
    const v = Number(item?.KmaiPT) || 0;
    return Math.max(0, Math.min(100, v));
  };

  const getDiscountedUnitPrice = (item) => {
    const base = Number(item?.price) || 0;
    const discount = getItemDiscountPercent(item);
    return base * (1 - discount / 100);
  };

  const getItemLineTotal = (item) => {
    const qty = Number(item?.quantity) || 0;
    return getDiscountedUnitPrice(item) * qty;
  };

  const isValidSaleQuantity = (value) => {
    const quantity = Number(value);
    return Number.isFinite(quantity) && quantity > 0;
  };

  const normalizeSaleQuantity = (value) => {
    const quantity = Number(value);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const normalizeLoSX = (value) => String(value || "").trim();

  const getProductLoSX = (product) =>
    normalizeLoSX(product?.LoSX || product?.loSX);

  const extractLoSXFromLoSearch = (value) => {
    const match = String(value || "")
      .trim()
      .match(/^lo\s*(\d+)$/i);
    return match ? match[1] : "";
  };

  const buildTrungThuQRProduct = (item, loSX) => ({
    id: item.MaSP,
    name: item.TenSP || item.Ten_SP || `Sản phẩm ${item.MaSP}`,
    price: Number(item.DonGia) || 0,
    price2: Number(item.DonGia2 || item.DonGia) || 0,
    image: getCategoryImage(item.MaNLSP || "TH"),
    unit: item.DVT_SP || item.DVT || "cái",
    vat: item.VAT_SP || 0,
    category: item.MaNLSP || "TRUNGTHU_QR",
    categoryName: item.TenLoaiSP || "Trung Thu QR",
    categoryId: item.MaNLSP || "TRUNGTHU_QR",
    loSX: normalizeLoSX(loSX || item.LoSX),
    LoaiBanh: TRUNG_THU_LOAI_BANH,
    isQR: true,
  });

  const calculateVoucherDiscount = (voucher, currentSubtotal) => {
    if (!voucher) return 0;

    const fixedAmount = Number(voucher.TienCK) || 0;
    if (fixedAmount > 0) {
      return fixedAmount;
    }

    const percent = Number(voucher.ChietKhau) || 0;
    if (percent > 0) {
      const safePercent = Math.max(0, Math.min(100, percent));
      return Math.floor((Number(currentSubtotal) || 0) * (safePercent / 100));
    }

    return 0;
  };

  // Handler for category selection
  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    setBanhMiFilter(null); // reset Bánh mì/Hamburger filter when switching categories
  };

  // Handler for adding product to order
  const handleAddToOrder = (product) => {
    // Price for the active channel (DonGia2 for Grab & Foody, else DonGia);
    // the line also keeps both prices so toggling Grab can reprice the cart.
    const pricedProduct = withChannelPrice(product, isGrabFoodyMode);
    const productLoSX = getProductLoSX(product);

    // Check if should create new line instead of incrementing quantity
    const loaiCH = localStorage.getItem("LoaiCH");
    const shouldCreateNewLine =
      !productLoSX &&
      loaiCH === "3" &&
      ["AK", "NLBL", "BMCN", "BMCN_HCM"].includes(product.category);

    setOrderItems((prevItems) => {
      if (product._uniqueId && (product._addonParent || isBreadWithFilling(product))) {
        return prevItems.map((item) => item._uniqueId === product._uniqueId ? { ...item, quantity: item.quantity + 1 } : item);
      }
      if (shouldCreateNewLine) {
        // Always create a new line for these categories in LoaiCH = 3
        return [
          ...prevItems,
          {
            ...pricedProduct,
            quantity: 1,
            category: product.category,
            note: "",
            KmaiPT: 0,
            _uniqueId: Date.now() + Math.random(),
          },
        ];
      }

      // Original logic: increment quantity if exists
      const existingItem = prevItems.find(
        (item) => item.id === product.id && getProductLoSX(item) === productLoSX && !item._addonParent && !item._hasAddons,
      );
      if (existingItem) {
        return prevItems.map((item) =>
          item === existingItem
            ? {
                ...item,
                quantity: item.quantity + 1,
                basePrice: pricedProduct.basePrice,
                price2: pricedProduct.price2,
                price: pricedProduct.price,
              }
            : item,
        );
      }

      return [
        ...prevItems,
        {
          ...pricedProduct,
          quantity: 1,
          category: product.category,
          note: "",
          KmaiPT: 0,
          ...(productLoSX
            ? { loSX: productLoSX, _uniqueId: Date.now() + Math.random() }
            : {}),
        },
      ];
    });
  };

  const extractLoSXFromQRCode = (qrData) => {
    const value = String(qrData || "").trim();
    if (!value) return "";

    try {
      const url = new URL(value);
      const code = url.searchParams.get("c");
      if (code) return code.trim();
    } catch (error) {
      // QR scanners sometimes pass only a fragment of the URL; regex handles it below.
    }

    const queryMatch = value.match(/[?&]c=(\d+)/i);
    if (queryMatch) return queryMatch[1];

    const doticomMatch = value.match(/doticom\.vn\/t\.php\?c=(\d+)/i);
    if (doticomMatch) return doticomMatch[1];

    const loSearchMatch = extractLoSXFromLoSearch(value);
    if (loSearchMatch) return loSearchMatch;

    return /^\d+$/.test(value) ? value : "";
  };

  const stopQRScannerCamera = () => {
    if (qrCameraStartTimeoutRef.current) {
      window.clearTimeout(qrCameraStartTimeoutRef.current);
      qrCameraStartTimeoutRef.current = null;
    }

    if (qrScanIntervalRef.current) {
      window.clearInterval(qrScanIntervalRef.current);
      qrScanIntervalRef.current = null;
    }

    if (qrCameraStreamRef.current) {
      qrCameraStreamRef.current.getTracks().forEach((track) => track.stop());
      qrCameraStreamRef.current = null;
    }

    if (qrVideoRef.current) {
      qrVideoRef.current.srcObject = null;
    }
  };

  const handleCloseQRScanner = () => {
    setShowQRScanner(false);
    setQrManualInput("");
    setQrCameraError("");
    stopQRScannerCamera();
  };

  const addProductsFromQRData = async (qrData) => {
    const loSX = extractLoSXFromQRCode(qrData);

    if (!loSX) {
      toast.error("Không đọc được mã LoSX từ QR.");
      return;
    }

    setQrProcessing(true);
    try {
      const response = await axios.get(`${POS_API_BASE_URL}/api/QRTrungThu`, {
        params: { LoSX: loSX },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      const qrItems = Array.isArray(response.data)
        ? response.data
        : response.data
          ? [response.data]
          : [];

      if (qrItems.length === 0) {
        toast.error(`Không tìm thấy sản phẩm với LoSX ${loSX}.`);
        return;
      }

      qrItems.forEach((item) => {
        const product = {
          id: item.MaSP,
          name: item.TenSP || item.Ten_SP || `Sản phẩm ${item.MaSP}`,
          price: Number(item.DonGia) || 0,
          price2: Number(item.DonGia2 || item.DonGia) || 0,
          image: getCategoryImage(item.MaNLSP || "TH"),
          unit: item.DVT_SP || item.DVT || "cái",
          vat: item.VAT_SP || 0,
          category: item.MaNLSP || "TRUNGTHU_QR",
          categoryName: item.TenLoaiSP || "Trung Thu QR",
          categoryId: item.MaNLSP || "TRUNGTHU_QR",
          loSX,
          isQR: true,
        };

        handleAddToOrder(product);
      });

      toast.success(
        `Đã thêm ${qrItems.length} sản phẩm từ QR LoSX ${loSX} vào giỏ.`,
      );
      handleCloseQRScanner();
    } catch (error) {
      console.error("Error processing QR Trung Thu:", error);
      toast.error("Lỗi xử lý QR. Vui lòng thử lại.");
    } finally {
      setQrProcessing(false);
    }
  };

  const scanQRFrame = () => {
    const video = qrVideoRef.current;
    const canvas = qrCanvasRef.current;

    if (!video || !canvas || video.readyState !== 4) return;

    const ctx = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    if (!canvas.width || !canvas.height) return;

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: "attemptBoth",
    });

    if (code?.data && !qrProcessing) {
      stopQRScannerCamera();
      addProductsFromQRData(code.data);
    }
  };

  const startQRScannerCamera = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setQrCameraError("Trình duyệt không hỗ trợ camera.");
      return;
    }

    try {
      setQrCameraError("");
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment",
          width: { ideal: 640 },
          height: { ideal: 480 },
        },
      });

      qrCameraStreamRef.current = stream;

      if (qrVideoRef.current) {
        qrVideoRef.current.srcObject = stream;
        qrVideoRef.current.onloadedmetadata = () => {
          qrVideoRef.current.play();
          qrScanIntervalRef.current = window.setInterval(scanQRFrame, 450);
        };
      }
    } catch (error) {
      console.error("QR camera error:", error);
      setQrCameraError("Không thể mở camera. Có thể nhập/scan mã QR vào ô bên dưới.");
    }
  };

  const handleOpenQRScanner = () => {
    setShowQRScanner(true);
    setShowPrintSettings(false);
    setShowDropdown(false);
    qrCameraStartTimeoutRef.current = window.setTimeout(() => {
      qrCameraStartTimeoutRef.current = null;
      startQRScannerCamera();
    }, 250);
  };

  const handleQRManualSubmit = () => {
    if (!qrManualInput.trim()) {
      toast.info("Vui lòng nhập mã QR hoặc LoSX.");
      return;
    }

    addProductsFromQRData(qrManualInput);
  };

  useEffect(() => {
    return () => {
      stopQRScannerCamera();
    };
  }, []);

  const triggerProductCardFlash = (element) => {
    if (!element) return;

    if (element._flashTimeoutId) {
      window.clearTimeout(element._flashTimeoutId);
    }

    element.classList.remove("product-card-flash");
    void element.offsetWidth;
    element.classList.add("product-card-flash");

    element._flashTimeoutId = window.setTimeout(() => {
      element.classList.remove("product-card-flash");
      element._flashTimeoutId = null;
    }, 420);
  };

  const handleProductCardClick = (product, event) => {
    triggerProductCardFlash(event.currentTarget);
    handleAddToOrder(product);
  };

  // Handler for removing product from order
  const handleRemoveFromOrder = (itemKey) => {
    setOrderItems((prevItems) => {
      // itemKey có thể là _uniqueId hoặc id
      const existingItem = prevItems.find(
        (item) => (item._uniqueId || item.id) === itemKey,
      );

      if (!existingItem) return prevItems;

      if (existingItem.quantity > 1) {
        return prevItems.map((item) =>
          (item._uniqueId || item.id) === itemKey
            ? { ...item, quantity: item.quantity - 1 }
            : item,
        );
      }

      return prevItems.filter((item) => (item._uniqueId || item.id) !== itemKey && String(item._addonParent || "") !== String(itemKey));
    });
  };

  // Handler for applying discount with prompt
  const handleApplyDiscountPrompt = () => {
    if (isEmployeeCustomer) {
      toast.info("Khách nhân viên đã áp dụng giảm 15%.");
      return;
    }
    const input = prompt("Nhập % giảm giá (0-100):");
    const percent = parseFloat(input);
    if (isNaN(percent) || percent < 0 || percent > 100) {
      toast.error("Vui lòng nhập giá trị hợp lệ từ 0 đến 100.");
      return;
    }
    setDiscountPercent(percent);
  };

  // Handler for applying discount from input
  const handleApplyDiscount = () => {
    if (isEmployeeCustomer) {
      toast.info("Khách nhân viên đã áp dụng giảm 15%.");
      return;
    }
    const percent = parseFloat(discountCode);
    if (isNaN(percent) || percent < 0 || percent > 100) {
      toast.error("Vui lòng nhập giá trị hợp lệ từ 0 đến 100.");
      return;
    }
    setDiscountPercent(percent);
  };

  // Handler áp dụng voucher
  const handleApplyVoucher = async () => {
    const request = ++voucherLookupRequest.current;
    setVoucherError("");
    setVoucherInfo(null);
    setVoucherDiscount(0);
    if (!voucherCode.trim()) {
      setVoucherError("Vui lòng nhập mã giảm giá.");
      return;
    }
    if (!customerInfo?.MaKH || !customerInfo?.SDT) {
      setVoucherError("Vui lòng chọn khách hàng trước khi áp dụng Voucher.");
      return;
    }
    try {
      const res = await axios.get(
        `${POS_API_BASE_URL}/api/customers/vouchers`,
        customerRequestOptions({ params: { phone: customerInfo.SDT, code: voucherCode.trim() } }),
      );
      if (request !== voucherLookupRequest.current) return;
      if (res.data?.data?.length === 1 && res.data.data[0].status === "available") {
        const voucher = res.data.data[0];
        setVoucherInfo(voucher);
        // Nếu có TienCK > 0 thì giảm tiền mặt, nếu không thì giảm theo % ChietKhau
        setVoucherDiscount(calculateVoucherDiscount(voucher, subtotal));
        toast.success("Áp dụng mã giảm giá thành công!");
      } else {
        setVoucherError("Mã giảm giá không hợp lệ hoặc đã hết hạn.");
        setVoucherInfo(null);
        setVoucherDiscount(0);
      }
    } catch (err) {
      if (request !== voucherLookupRequest.current) return;
      setVoucherError("Không thể kiểm tra mã giảm giá.");
      setVoucherInfo(null);
      setVoucherDiscount(0);
    }
  };

  // Calculate order totals
  const subtotal = orderItems.reduce(
    (sum, item) => sum + getItemLineTotal(item),
    0,
  );
  // Check if customer has membership = 1 for automatic 15% discount
  const membershipDiscountPercent = customerInfo?.Membership === "1" ? 15 : 0;
  const membershipDiscountAmount = subtotal * (membershipDiscountPercent / 100);
  const isEmployeeCustomer = customerInfo?.Membership === "1";

  const discountAmount = subtotal * (discountPercent / 100);

  // Tính số tiền giảm từ điểm tiêu (1 điểm = 1đ)
  const currentCustomerPoint = Math.max(
    0,
    parseInt(customerInfo?.DiemTichLuy, 10) || 0,
  );
  const maxUsePointByBill = Math.max(
    Math.floor(
      subtotal -
        discountAmount -
        membershipDiscountAmount -
        voucherDiscount -
        cashDiscount,
    ),
    0,
  );
  const usePointValue = Math.max(0, Math.floor(Number(usePoint) || 0));
  const usePointDiscount = Math.min(
    usePointValue,
    currentCustomerPoint,
    maxUsePointByBill,
  );

  // Tổng tiền sau giảm giá, voucher, membership discount và trừ điểm tiêu
  const total = Math.max(
    subtotal -
      discountAmount -
      membershipDiscountAmount -
      voucherDiscount -
      usePointDiscount -
      cashDiscount,
    0,
  );

  useEffect(() => {
    if (!voucherInfo) {
      setVoucherDiscount(0);
      return;
    }

    setVoucherDiscount(calculateVoucherDiscount(voucherInfo, subtotal));
  }, [voucherInfo, subtotal]);

  // Xử lý nhập SĐT khách hàng
  const handlePhoneInputChange = (e) => {
    customerSearchId.current += 1;
    setCustomerPhone(e.target.value);
    setCustomerInfo(null);
    setUsePoint("");
    localStorage.removeItem("currentCustomerInfo");
  };

  const handleLookupBusiness = async () => {
    if (customerLoading) return;
    setVerifiedBusinessTaxCode("");
    let taxCode;
    try {
      taxCode = normalizeBusinessTaxCode(newCustomerTaxCode);
    } catch (error) {
      toast.error(error.message);
      return;
    }

    const requestId = ++businessLookupRequestRef.current;
    setCustomerLoading(true);
    setCustomerInfo(null);
    setUsePoint("");
    setNewCustomerName("");
    setNewCustomerAddress("");
    setNewCustomerTaxCode(taxCode);
    setShowNewCustomerForm(false);
    localStorage.removeItem("currentCustomerInfo");
    localStorage.removeItem("currentCustomerUsePoint");
    try {
      const business = await lookupBusinessByTaxCode(taxCode);
      if (requestId !== businessLookupRequestRef.current) return;
      setNewCustomerName(business.name);
      setNewCustomerAddress(business.address);
      setNewCustomerTaxCode(business.taxCode);
      setVerifiedBusinessTaxCode(business.taxCode);
      toast.success("Đã điền thông tin doanh nghiệp cho hóa đơn. Email và SĐT không bắt buộc.");
    } catch (error) {
      if (requestId !== businessLookupRequestRef.current) return;
      toast.error(error.message);
    } finally {
      if (requestId === businessLookupRequestRef.current) setCustomerLoading(false);
    }
  };

  // Tìm kiếm khách hàng theo SĐT hoặc tra doanh nghiệp theo MST
  const handleSearchCustomer = async () => {
    if (customerLoading) return;
    if (customerSearchType === "taxCode") {
      await handleLookupBusiness();
      return;
    }
    if (!customerPhone.trim()) {
      toast.error("Vui lòng nhập số điện thoại.");
      return;
    }
    const searchId = ++customerSearchId.current;
    setCustomerLoading(true);
    setShowNewCustomerForm(false);
    setCustomerInfo(null);
    setUsePoint("");
    localStorage.removeItem("currentCustomerInfo");
    localStorage.removeItem("currentCustomerUsePoint");
    try {
      const customer = await findCustomerByPhone(POS_API_BASE_URL, customerPhone);
      if (searchId !== customerSearchId.current) return;
      if (!customer) {
        toast.info("Không tìm thấy khách hàng. Có thể thêm mới.");
        setShowNewCustomerForm(true);
        return;
      }
      const selected = { ...customer, Membership: String(customer.Membership || "Classic").trim() };
      setCustomerInfo(selected);
      localStorage.setItem("currentCustomerInfo", JSON.stringify(selected));
      toast.success(`Đã tìm thấy khách hàng: ${selected.Ten || selected.TenKH}`);
    } catch (error) {
      if (searchId === customerSearchId.current) toast.error(error.response?.data?.message || error.message);
    } finally {
      if (searchId === customerSearchId.current) setCustomerLoading(false);
    }
  };

  // Tạo mới khách hàng
  const handleCreateNewCustomer = async (e) => {
    e.preventDefault();
    if (customerSearchType === "taxCode") return;
    if (!newCustomerName.trim() || !customerPhone.trim()) {
      toast.error("Tên khách hàng và số điện thoại là bắt buộc.");
      return;
    }
    setCustomerLoading(true);
    try {
      const response = await axios.post(
        `${POS_API_BASE_URL}/customers/add`,
        {
          Ten: newCustomerName,
          SDT: normalizeCustomerPhoneToLocal(customerPhone),
          DiaChi: newCustomerAddress,
          MST: newCustomerTaxCode,
          DiemTichLuy: 0,
        },
        customerRequestOptions(),
      );
      setCustomerInfo(response.data);
      localStorage.setItem(
        "currentCustomerInfo",
        JSON.stringify(response.data),
      );
      toast.success(`Đã thêm khách hàng mới: ${newCustomerName}`);
      setShowNewCustomerForm(false);
      setNewCustomerName("");
      setNewCustomerAddress("");
      setNewCustomerTaxCode("");
      setCustomerLoading(false); // <-- Thêm dòng này để dừng loading
    } catch (error) {
      toast.error(error.response?.data?.message || "Lỗi khi thêm khách hàng mới.");
      setCustomerLoading(false); // <-- Thêm dòng này để dừng loading khi lỗi
    }
  };

  // State cho modal xác nhận thanh toán
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const giftDrinks = useOrderGiftDrinks({
    apiBase: POS_API_BASE_URL,
    storeId: localStorage.getItem("IDCH"),
    storeScope: storeName,
    items: orderItems,
  });
  const transferQRCodeRef = React.useRef(null);

  const handlePrintTransferQR = () => {
    const qrImage = transferQRCodeRef.current;
    if (!qrImage?.complete || !qrImage.naturalWidth) {
      toast.error("Mã QR chưa tải xong. Vui lòng thử lại.");
      return;
    }

    const printWindow = window.open("", "_blank", "width=400,height=500");
    if (!printWindow) {
      toast.error("Không thể mở cửa sổ in. Vui lòng cho phép cửa sổ bật lên.");
      return;
    }

    printWindow.document.write(`<!DOCTYPE html>
<html lang="vi">
  <head>
    <meta charset="UTF-8" />
    <title>In mã QR thanh toán</title>
    <style>
      @page { margin: 4mm; }
      body { margin: 0; text-align: center; }
      img { display: block; width: 40mm; height: 40mm; margin: 0 auto; }
      p { margin: 3mm auto 0; max-width: 72mm; font: 12px Arial, sans-serif; white-space: pre-line; }
    </style>
  </head>
  <body></body>
</html>`);
    printWindow.document.close();
    printWindow.addEventListener("afterprint", () => printWindow.close(), {
      once: true,
    });

    const printImage = printWindow.document.createElement("img");
    printImage.alt = "QR thanh toán chuyển khoản";
    printImage.onload = () => {
      if (printWindow.closed) return;
      printWindow.focus();
      printWindow.print();
    };
    printImage.onerror = () => {
      printWindow.close();
      toast.error("Không tải được mã QR để in. Vui lòng thử lại.");
    };
    printWindow.document.body.appendChild(printImage);
    const paymentDescription = printWindow.document.createElement("p");
    paymentDescription.textContent = "Vui lòng quét mã thanh toán\nSố tiền: ";
    const paymentAmount = printWindow.document.createElement("strong");
    paymentAmount.textContent = String(total);
    paymentDescription.appendChild(paymentAmount);
    printWindow.document.body.appendChild(paymentDescription);
    printImage.src = qrImage.currentSrc || qrImage.src;
  };

  const [showPaymentQRZoom, setShowPaymentQRZoom] = useState(false);
  const bankAccount = String(localStorage.getItem("stk") || "").trim();
  const bankName = String(localStorage.getItem("bank_name") || "").trim();
  const hasPaymentBank = [bankAccount, bankName].every(
    (value) => value && !["null", "undefined"].includes(value.toLowerCase()),
  );
  const transferQRCodeSrc = hasPaymentBank
    ? buildOrderTransferQRCode({
        account: bankAccount, bank: bankName, total,
        storeName: localStorage.getItem("TenCuaHang"),
      })
    : null;
  const paymentQRCodeSrc = paymentMethod === "transfer"
    ? transferQRCodeSrc
    : "/qr.png";

  useEffect(() => {
    setShowPaymentQRZoom(false);
  }, [showConfirmModal, paymentMethod]);

  useEffect(() => {
    if (!showPaymentQRZoom) return;
    const handleZoomKeyDown = (event) => {
      if (["Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(event.key)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.key === "Escape") setShowPaymentQRZoom(false);
      }
    };
    document.addEventListener("keydown", handleZoomKeyDown, true);
    return () => document.removeEventListener("keydown", handleZoomKeyDown, true);
  }, [showPaymentQRZoom]);

  // Định nghĩa hàm mở/đóng modal ở đây để tránh lỗi no-undef
  const handleOpenConfirmModal = () => setShowConfirmModal(true);
  const handleGiftDrinksCheckout = () => {
    setShowCartModal(false);
    handleOpenConfirmModal();
  };
  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
    if (customerSearchType === "taxCode") {
      businessLookupRequestRef.current += 1;
      setCustomerLoading(false);
      setNewCustomerName("");
      setNewCustomerAddress("");
      setNewCustomerTaxCode("");
      setBusinessPhone("");
      setBusinessEmail("");
      setVerifiedBusinessTaxCode("");
      setShowNewCustomerForm(false);
    }
    localStorage.removeItem("currentCustomerInfo");
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      // Check if user is typing in an input field
      const activeElement = document.activeElement;
      const isInputField =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable);

      // Check if Enter key is pressed, checkout button is active, and not in input field
      if (
        event.key === "Enter" &&
        orderItems.length > 0 &&
        !showConfirmModal &&
        !showPrintSettings &&
        !isInputField
      ) {
        event.preventDefault();
        handleOpenConfirmModal();
      }
    };

    // Add event listener
    document.addEventListener("keydown", handleKeyPress);

    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [orderItems.length, showConfirmModal, showPrintSettings]);

  // State cho số tiền khách đưa trong modal
  const [cashGiven, setCashGiven] = useState("");
  const [change, setChange] = useState(0);
  const [isCashGivenAutofilled, setIsCashGivenAutofilled] = useState(false);

  const sanitizeCashInput = (value) =>
    value.replace(/[^\d]/g, "").replace(/^0+(?=\d)/, "");

  const autofillCashGiven = React.useCallback(() => {
    setCashGiven(total.toString());
    setIsCashGivenAutofilled(true);
  }, [total]);

  const resetCashGiven = React.useCallback(() => {
    setCashGiven("");
    setIsCashGivenAutofilled(false);
  }, []);

  const handleCashGivenChange = (value) => {
    setCashGiven(sanitizeCashInput(value));
    setIsCashGivenAutofilled(false);
  };

  // Xử lý nhập số tiền khách đưa từ bàn phím custom
  const handleCustomKeyboardClick = (val) => {
    if (val === "C") {
      resetCashGiven();
      setChange(0);
      return;
    }
    const baseValue = isCashGivenAutofilled ? "" : cashGiven;
    let newValue = sanitizeCashInput(baseValue + val);
    setCashGiven(newValue);
    setIsCashGivenAutofilled(false);
  };

  // Khi cashGiven thay đổi, tính lại tiền thối
  useEffect(() => {
    const cash = parseInt(cashGiven || "0", 10);
    setChange(cash - total);
  }, [cashGiven, total]);

  // Chỉ khởi tạo dữ liệu đúng 1 lần khi modal vừa mở
  useEffect(() => {
    if (!showConfirmModal) return;

    const currentPaymentMethod = paymentMethodRef.current;

    if (!currentPaymentMethod) {
      if (isGrabFoodyMode) {
        setPaymentMethod("shopee");
      } else {
        setPaymentMethod("cash");
        autofillCashGiven();
      }
    } else if (currentPaymentMethod !== "cash") {
      resetCashGiven();
    } else {
      autofillCashGiven();
    }

    setChange(0);

    const loaiCH = localStorage.getItem("LoaiCH");
    if (loaiCH === "0") setSelectedTable(null);
  }, [
    showConfirmModal,
    isGrabFoodyMode,
    autofillCashGiven,
    resetCashGiven,
  ]);

  useEffect(() => {
    if (!showConfirmModal) return;

    const handleModalKeyPress = (event) => {
      const activeElement = document.activeElement;
      const isInputField =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable);

      const paymentMethods = isGrabFoodyMode
        ? ["grab", "shopee"]
        : ["cash", "transfer"];

      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        event.preventDefault();
        const currentIndex = paymentMethods.indexOf(paymentMethod);
        let newIndex;

        if (event.key === "ArrowLeft") {
          newIndex =
            currentIndex <= 0 ? paymentMethods.length - 1 : currentIndex - 1;
        } else {
          newIndex =
            currentIndex >= paymentMethods.length - 1 ? 0 : currentIndex + 1;
        }

        setPaymentMethod(paymentMethods[newIndex]);
      }

      if (event.key === "Enter" && !isInputField && !isProcessing) {
        const canCheckout = isGrabFoodyMode
          ? paymentMethod !== null &&
            (paymentMethod === "grab" || paymentMethod === "shopee")
          : (paymentMethod === "cash"
              ? parseInt(cashGiven || "0", 10) >= total
              : paymentMethod !== null) &&
            (localStorage.getItem("LoaiCH") !== "0" || selectedTable);

        if (canCheckout) {
          event.preventDefault();
          handleCheckoutSafeRef.current?.();
        }
      }
    };

    document.addEventListener("keydown", handleModalKeyPress);

    return () => {
      document.removeEventListener("keydown", handleModalKeyPress);
    };
  }, [
    showConfirmModal,
    paymentMethod,
    cashGiven,
    total,
    isGrabFoodyMode,
    selectedTable,
    isProcessing,
  ]);

  // Tạo HTML bill để in bằng window.print
  // Process payment
  const handleCheckout = async () => {
    if (orderItems.length === 0) {
      toast.error("Please add items to your order first");
      return false;
    }

    if (customerLoading) {
      toast.info("Vui lòng chờ tra cứu thông tin khách hàng hoàn tất.");
      return false;
    }

    const invalidQuantityItem = orderItems.find(
      (item) => !isValidSaleQuantity(item.quantity),
    );

    if (invalidQuantityItem) {
      toast.error(
        `Số lượng bán của ${invalidQuantityItem.name || invalidQuantityItem.id} phải lớn hơn 0. Vui lòng sửa số lượng hoặc xóa sản phẩm khỏi giỏ.`,
      );
      return false;
    }

    const giftItems = await giftDrinks.validateForCheckout();
    if (giftItems === null) {
      setShowConfirmModal(true);
      toast.error("Chưa xác nhận được nước tặng. Vui lòng kiểm tra ưu đãi hoặc bỏ chọn nước để tiếp tục.");
      return false;
    }
    const checkoutItems = [...orderItems, ...giftItems];

    // Retrieve user details from local storage
    const MaNV = localStorage.getItem("MaNV") || "unknown_employee";
    const IDCH = localStorage.getItem("IDCH") || "unknown_store_id";
    const TenCuaHang = localStorage.getItem("TenCuaHang") || "Unknown Store";
    const DiaChiCH = localStorage.getItem("Address") || "Unknown Address";
    const SdtCH = localStorage.getItem("Phone") || "Unknown Phone";
    const TenNV = localStorage.getItem("TenUser") || "Unknown User";
    const storedCustomerInfo =
      customerSearchType === "taxCode"
        ? null
        : customerInfo;
    const businessCustomerInfo =
      customerSearchType === "taxCode"
        ? {
            Ten: newCustomerName.trim(),
            MST: newCustomerTaxCode.trim(),
            DiaChi: newCustomerAddress.trim(),
            SDT: businessPhone.trim(),
            Email: businessEmail.trim(),
          }
        : null;
    const invoiceCustomerInfo =
      businessCustomerInfo && Object.values(businessCustomerInfo).some(Boolean)
        ? businessCustomerInfo
        : storedCustomerInfo;
    const invoiceCustomerName = invoiceCustomerInfo?.Ten || "Khách lẻ";
    const TieuDiem = usePointDiscount;
    const ipBanhNgot = localStorage.getItem("IpBanhNgot") || "";
    const HeSoTichDiem = storedCustomerInfo?.HeSo_TichDiem ?? 0.02;
    console.log("HeSoTichDiem:", HeSoTichDiem);

    const cashGivenValue = parseInt(cashGiven || "0", 10);

    // Calculate totalAmount with all discounts
    const GiamTMTheVIP = voucherDiscount || 0;
    const GiamTienMat = cashDiscount || 0;
    const effectiveGiamPT = Math.min(
      100,
      (Number(discountPercent) || 0) + (Number(membershipDiscountPercent) || 0),
    );
    const discountFromPercent = subtotal * (effectiveGiamPT / 100);
    const totalAmount = Math.max(
      subtotal - (TieuDiem + GiamTMTheVIP + GiamTienMat + discountFromPercent),
      0,
    );

    // Determine payment method value and note
    let phuongThucThanhToan = 0;

    let ghiChu = "";

    switch (paymentMethod) {
      case "cash":
        phuongThucThanhToan = "0";
        ghiChu = "Tiền mặt";
        break;
      case "transfer":
        phuongThucThanhToan = "1";
        ghiChu = "Chuyển khoản";
        break;
      case "card":
        phuongThucThanhToan = "1.1";
        ghiChu = "Quẹt thẻ";
        break;
      case "momo":
        phuongThucThanhToan = "1.2";
        ghiChu = "Ví Momo";
        break;
      case "vnpay":
        phuongThucThanhToan = "1.3";
        ghiChu = "Ví Vnpay";
        break;
      case "grab":
        phuongThucThanhToan = "1.4";
        ghiChu = "Grab";
        break;
      case "shopee":
        phuongThucThanhToan = "1.5";
        ghiChu = "Shopee";
        break;
      case "notPaid":
        phuongThucThanhToan = "2";
        ghiChu = "Nợ";
        break;
      default:
        phuongThucThanhToan = "0";
        ghiChu = "Tiền mặt";
    }
    let finalBillNote = ghiChu;
    if (isGrabFoodyMode && shipperPaymentMethod) {
      const shipperNote = shipperPaymentMethod === "cash" ? "FDTM" : "FDCK";
      finalBillNote = shipperNote + (ghiChu ? " - " + ghiChu : "");
    }
    const billLoaiBanh = getBillLoaiBanh(orderItems);

    const billDetails = {
      storeId: IDCH,
      totalAmount,
      cashGiven: cashGivenValue,
      change: cashGivenValue === 0 ? 0 : cashGivenValue - totalAmount,
      MaTheVIP: storedCustomerInfo?.MaKH || "",
      GiamPT: effectiveGiamPT,
      GiamTienMat,
      GiamTMTheVIP,
      VoucherCode: voucherInfo ? voucherInfo.MaCK : "",
      employeeName: TenNV,
      TenKH: invoiceCustomerName,
      MaKH: storedCustomerInfo?.MaKH || "",
      ipBanhNgot: ipBanhNgot || "",
      HeSoTichDiem: HeSoTichDiem || "1",
      TieuDiem: TieuDiem || 0,
      PhuongThucThanhToan: phuongThucThanhToan,
      GhiChu: finalBillNote,
      LoaiBanh: billLoaiBanh,
      // Thêm số bàn nếu LoaiCH === "0"
      ...(localStorage.getItem("LoaiCH") === "0" && selectedTable
        ? { tableNumber: selectedTable }
        : {}),
      items: checkoutItems.map((item) => ({
        id: item.id,
        name: `${item.name}${
          item.unit ? " [" + mapUnitToVietnamese(item.unit) + "]" : ""
        }`,
        quantity: item.quantity,
        unitPrice: Number(item.price) || 0,
        KmaiPT: Number(item.KmaiPT) || 0,
        ThanhTien: getItemLineTotal(item),
        MXTY: item.MXTY || 0,
        LoSX: getProductLoSX(item),
        LoaiBanh: getProductLoaiBanh(item),
        note: item.note || "", // Lưu ghi chú vào billDetails.items.note
      })),
      // Khách MST không có MaKH: BE lưu thông tin doanh nghiệp vào Sale_InvoiceBuyer theo IDXuat,
      // để service thuế gửi lại bill vẫn giữ MST. Luồng in nhận cùng thông tin qua customerInfo.
      customerInfo: storedCustomerInfo || undefined,
      invoiceBuyer: businessCustomerInfo?.MST ? businessCustomerInfo : undefined,
    };
    const billDetailForPrinter = {
      storeId: IDCH,
      totalAmount,
      cashGiven: cashGivenValue,
      change: cashGivenValue === 0 ? 0 : cashGivenValue - totalAmount,
      MaTheVIP: storedCustomerInfo?.MaKH || "",
      GiamPT: effectiveGiamPT,
      GiamTienMat,
      GiamTMTheVIP,
      employeeName: TenNV,
      TenKH: invoiceCustomerName,
      MaKH: storedCustomerInfo?.MaKH || "",
      ipBanhNgot: ipBanhNgot || "",
      HeSoTichDiem: HeSoTichDiem || "1",
      TieuDiem: TieuDiem || 0,
      PhuongThucThanhToan: phuongThucThanhToan,
      GhiChu: finalBillNote,
      LoaiBanh: billLoaiBanh,
      // Thêm số bàn nếu LoaiCH === "0"
      ...(localStorage.getItem("LoaiCH") === "0" && selectedTable
        ? { tableNumber: selectedTable }
        : {}),
      items: checkoutItems.map((item) => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        unitPrice: Number(item.price) || 0,
        unit: item.unit || item.DVT_SP || item.DVT || "cái",
        KmaiPT: Number(item.KmaiPT) || 0,
        ThanhTien: getItemLineTotal(item),
        MXTY: item.MXTY || 0,
        LoSX: getProductLoSX(item),
        LoaiBanh: getProductLoaiBanh(item),
        note: item.note || "", // Lưu ghi chú vào billDetails.items.note
      })),
      // --- Thêm thông tin khách hàng để gửi lên thuế ---
      customerInfo: invoiceCustomerInfo || undefined,
    };
    const hasVerifiedBusiness =
      customerSearchType === "taxCode" &&
      Boolean(businessCustomerInfo?.Ten) &&
      Boolean(verifiedBusinessTaxCode) &&
      verifiedBusinessTaxCode.replace(/-/g, "") === businessCustomerInfo.MST.replace(/-/g, "");
    const isFullyDiscountedBill =
      totalAmount === 0 &&
      orderItems.length > 0 &&
      orderItems.every((item) => getItemDiscountPercent(item) === 100);
    let puller;
    if (isFullyDiscountedBill) {
      puller = 0;
    } else if (hasVerifiedBusiness) {
      puller = 1;
    } else if (phuongThucThanhToan === "2") {
      puller = 0;
    } else if (
      ["1", "1.1", "1.2", "1.3", "1.4", "1.5"].includes(phuongThucThanhToan)
    ) {
      puller = 1;
    } else {
      puller = null;
    }
    const body = {
      billDetails,
      puller,
      LoaiBanh: billLoaiBanh,
    };
    const IDXuat = billDetails.IDXuat || billDetails.idxuat || null;

    try {
      const saveDBResponse = await saveCustomerSale(POS_API_BASE_URL, body);
      billDetailForPrinter.loyalty = saveDBResponse.data.loyalty;
      let pulling = null;
      let savedPull = null;
      let PrintIDXuat = IDXuat;
      const billId = saveDBResponse?.data?.billId || "";
      if (saveDBResponse.status === 200) {
        const saveData = saveDBResponse.data;
        savedPull = saveData.pull;
        pulling = JSON.stringify(savedPull);
        PrintIDXuat = saveData.IDXuat || IDXuat;
        console.log("Save to DB successful &&&****:", pulling);
      }

      // Voucher consumption is committed atomically with the bill by the backend.

      // Sau khi lưu DB thành công, gọi API in hóa đơn
      const printBody = {
        billDetails: billDetailForPrinter,
        orderId: `HD${Date.now()}`,
        cashier: MaNV, // Use MaNV from local storage
        // tableNumber: selectedTable, // Include table number in print body // Removed
        items: checkoutItems.map((item) => ({
          id: item.id,
          name: item.name,
          quantity: item.quantity,
          unitPrice: Number(item.price) || 0,
          unit: item.unit || item.DVT_SP || item.DVT || "cái",
          note: item.note || "",
          isQR: false,
          Sale_OrderMR: "",
          ThanhTien: getItemLineTotal(item),
          category: item.category || "Unknown",
          MaSP: item.id,
          VAT_SP: item.vat || 0,
          KmaiPT: Number(item.KmaiPT) || 0,
          MXTY: item.MXTY || 0,
          LoaiBanh: getProductLoaiBanh(item),
        })),
        storeName: TenCuaHang, // Use TenCuaHang from local storage
        ipThuNgan: localStorage.getItem("IpBep"), // This might need to be dynamic or configured
        ipBep: localStorage.getItem("IpBep"), // This might need to be dynamic or configured
        pull: pulling,
        billId,
        IDXuat: PrintIDXuat,
        LoaiBanh: billLoaiBanh,
      };

      let taxInfo = null;
      let serviceNumberCounter = null;
      const ipMayTinh = localStorage.getItem("IpMayTinh") || DEFAULT_PRINT_HOST;

      // Chỉ gọi API print nếu isDisablePrintAPI = false
      if (!isDisablePrintAPI) {
        try {
          const printRes = await axios.post(
            `https://${ipMayTinh}/print`,
            printBody,
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          if (printRes && printRes.data && typeof printRes.data === "object") {
            taxInfo = {
              invoiceNo: printRes.data.invoiceNo,
              invoiceSerial: printRes.data.invoiceSerial,
              mtc: printRes.data.mtc,
              taxOfficeCode: printRes.data.taxOfficeCode,
            };
            if (printRes.data.serviceNumberCounter) {
              serviceNumberCounter = printRes.data.serviceNumberCounter;
            }
          }
        } catch (err) {
          // Không alert khi in lỗi, chỉ log
          console.error(
            `Print API error (POST https://${ipMayTinh}/print):`,
            err.message,
          );

          let printErrorMessage =
            "Không thể in hóa đơn. Vui lòng kiểm tra kết nối máy in hoặc liên hệ quản trị viên.";
          if (err.isAxiosError && !err.response) {
            const clientOrigin = window.location.origin;
            console.error(
              `This is likely a CORS (Cross-Origin Resource Sharing) issue. ` +
                `The browser sent an OPTIONS preflight request to "https://${ipMayTinh}/print", ` +
                `but the server's response did not include the necessary CORS headers. ` +
                `To resolve this, the server at "https://${ipMayTinh}" needs to be configured to send the following headers in response to an OPTIONS request for the "/print" path:\n` +
                `  - Access-Control-Allow-Origin: ${clientOrigin}\n` +
                `  - Access-Control-Allow-Methods: POST, OPTIONS\n` +
                `  - Access-Control-Allow-Headers: Content-Type\n` +
                `Please check the browser's Network tab (specifically the OPTIONS request) and Console for detailed error messages from the browser.`,
            );
            printErrorMessage =
              "Lỗi cấu hình CORS khi cố gắng in hóa đơn. Máy chủ in không cho phép yêu cầu từ trang web này. Vui lòng liên hệ quản trị viên.";
          } else if (err.response) {
            console.error(
              "Print API - Server responded with an error. Status:",
              err.response.status,
              "Data:",
              err.response.data,
            );
            printErrorMessage = `Lỗi từ máy chủ in: ${err.response.status}. Không thể in hóa đơn.`;
          }
          // Log the full error object for more details if needed
          // console.error('Full error details:', err.toJSON ? err.toJSON() : err);

          // Toast the user about the print failure
          toast.error(printErrorMessage);

          if (savedPull === "1" || savedPull === 1) {
            if (
              PrintIDXuat === null ||
              PrintIDXuat === undefined ||
              String(PrintIDXuat).trim() === ""
            ) {
              console.error(
                "Không thể cập nhật Act_T=2 sau lỗi in vì thiếu IDXuat.",
              );
              toast.error(
                "Không thể cập nhật trạng thái hóa đơn sau lỗi in vì thiếu IDXuat.",
              );
            } else {
              try {
                const updateTaxInfoResponse = await axios.post(
                  UPDATE_TAX_INFO_AFTER_PRINT_FAILURE_URL,
                  {
                    TaxInfo: "",
                    Act_T: 2,
                    IDXuat: String(PrintIDXuat),
                  },
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                );

                if (updateTaxInfoResponse?.data?.success === false) {
                  throw new Error(
                    updateTaxInfoResponse.data.message ||
                      "API updateTaxInfo trả về thất bại.",
                  );
                }
              } catch (updateTaxInfoError) {
                console.error(
                  "Lỗi cập nhật Act_T=2 sau khi in thất bại:",
                  updateTaxInfoError,
                );
                toast.error(
                  "In thất bại và không thể cập nhật trạng thái hóa đơn. Vui lòng liên hệ quản trị viên.",
                );
              }
            }
          }
        }
      }

      // --- In bill bằng máy in USB qua window.print ---
      const displayTaxInfo =
        taxInfo && taxInfo.invoiceNo
          ? taxInfo
          : {
              invoiceNo: "00000000",
              invoiceSerial: "C26MYY",
              mtc: "",
              taxOfficeCode: "M1-26-1NDOW-00000000000",
            };
      const taxHtml = `
        <hr/>
        <div style="font-size:14px;">
          <b>Thông tin hóa đơn điện tử:</b><br/>
          Số hóa đơn: <b>${displayTaxInfo.invoiceNo}</b><br/>
          Ký hiệu: <b>${displayTaxInfo.invoiceSerial || ""}</b><br/>
          Mã tra cứu: <b>${displayTaxInfo.mtc || ""}</b><br/>
          Mã CQ Thuế: <b>${displayTaxInfo.taxOfficeCode || ""}</b>
           <div>Giá trên đã bao gồm thuế - Phiếu thanh toán chỉ có giá trị xuất hóa đơn trong vòng 120 phút và trước 22h trong ngày mua hàng</div>
        </div>
        `;

      // --- Lấy thông tin khách hàng và tính điểm tích lũy mới ---
      const printCustomerInfo = invoiceCustomerInfo;
      const escapeCustomerText = (value) => String(value ?? "").replace(
        /[&<>"']/g,
        (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[character],
      );
      const diemTichLuyMoi = saveDBResponse.data.loyalty?.DiemConlai ?? "Chưa xác nhận";

      // --- Bill HTML mới ---
      const billHtml = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>Hóa đơn bán hàng</title>

    <style>
      /* RESET TOÀN BỘ */
      * {
        box-sizing: border-box;
      }

      html, body {
        margin: 0;
        padding: 0;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 14px;
        color: #000;
      }

      /* CẤU HÌNH IN – QUAN TRỌNG */
      @media print {
        @page {
          size: 58mm auto;   /* đổi 80mm nếu máy 80 */
          margin: 0;         /* BẮT BUỘC */
        }

        body {
          margin: 0;
          padding: 0;
        }
      }

      /* CHỐNG MARGIN-COLLAPSE */
      h1, h2, h3, h4 {
        margin-top: 0;
        margin-bottom: 6px;
      }

      h3 {
        text-align: center;
        font-size: 16px;
      }

      .stt {
        text-align: left;
        font-size: 18px;
        font-weight: bold;
        margin: 6px 0;
      }

      hr {
        border: none;
        border-top: 1px dashed #000;
        margin: 6px 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin-top: 6px;
      }

      th, td {
        border: 1px solid #000;
        padding: 4px;
        font-size: 13px;
        text-align: left;
      }

      th {
        font-weight: bold;
      }

      .total {
        font-weight: bold;
        font-size: 16px;
        margin-top: 6px;
      }

      .note {
        margin-top: 4px;
        font-size: 13px;
      }
    </style>
  </head>

  <body>
    <!-- neo dòng đầu, tránh một số driver auto-feed -->
    <div style="height:1px; line-height:1px;"></div>

    <div class="bill-copy">
      <h3>${TenCuaHang}</h3>
      <div><b>Địa chỉ:</b> ${DiaChiCH}</div>
      <div><b>SĐT:</b> ${SdtCH}</div>

      <div>Ngày: ${new Date().toLocaleString()}</div>
      <div>
        Thu ngân: ${TenNV} -
        <b>Mã HD:</b> ${billId || "N/A"}
      </div>

      ${
        serviceNumberCounter
          ? `<div class="stt">Số: ${serviceNumberCounter}</div>`
          : ""
      }

      <hr/>

      <div>
        <b>Khách hàng:</b> ${escapeCustomerText(invoiceCustomerName)}<br/>
        ${
          printCustomerInfo
            ? `
              <b>SĐT:</b> ${
                escapeCustomerText(printCustomerInfo?.SDT || printCustomerInfo?.Sdt || "")
              }<br/>
              ${printCustomerInfo.Email ? `<b>Email:</b> ${escapeCustomerText(printCustomerInfo.Email)}<br/>` : ""}
              ${customerSearchType !== "taxCode" ? `<b>Điểm tích lũy:</b> ${diemTichLuyMoi.toLocaleString()}` : ""}
            `
            : ""
        }
      </div>

      <hr/>

      <table>
        <thead>
          <tr>
            <th>Sản phẩm</th>
            <th>SL</th>
            <th>Đơn giá</th>
            <th>Thành tiền</th>
          </tr>
        </thead>
        <tbody>
          ${buildOrderReceiptRows(billDetails.items)}
        </tbody>
      </table>

      <hr/>

      <div>Tạm tính: ${subtotal.toLocaleString()}₫</div>

      ${
        discountPercent > 0
          ? `<div>Giảm giá: -${discountAmount.toLocaleString()}₫</div>`
          : ""
      }

      ${
        cashDiscount > 0
          ? `<div>Giảm tiền mặt: -${cashDiscount.toLocaleString()}₫</div>`
          : ""
      }

      ${
        voucherDiscount > 0
          ? `<div>Voucher: -${voucherDiscount.toLocaleString()}₫</div>`
          : ""
      }

      ${
        usePointDiscount > 0
          ? `<div>Trừ điểm: -${usePointDiscount.toLocaleString()}₫</div>`
          : ""
      }

      <div class="total">
        Thành tiền: ${total.toLocaleString()}₫
      </div>

      ${paymentMethod === "transfer" ? buildOrderReceiptQR(transferQRCodeSrc, totalAmount) : ""}

      <hr/>

      <div style="text-align:center; font-weight:500;">
        Cảm ơn quý khách!
      </div>

      ${
        billNote || ghiChu
          ? `
            <div class="note">
              <b>Note:</b>
              ${billNote ? billNote.replace(/\\n/g, "<br/>") : ""}
              ${billNote && ghiChu ? " - " : ""}
              ${ghiChu || ""}
            </div>
          `
          : ""
      }

      <hr/>

      ${taxHtml || ""}
    </div>

    <script>
      window.onload = function () {
        window.print();
        setTimeout(function () {
          window.close();
        }, 500);
      };
    </script>
  </body>
</html>
`;

      if (isPrintEnabled) {
        // Check if print is enabled
        const printWindow = window.open("", "_blank", "width=400,height=600");
        if (printWindow) {
          printWindow.document.write(billHtml);
          printWindow.document.close();
        }
      }

      // Backend records points atomically with the bill.


      // Chỉ hiển thị thanh toán thành công và reset nếu lưu DB thành công
      // Quyết định xem có nên reset giỏ hàng nếu in lỗi hay không. Hiện tại, vẫn reset.
      toast.success(
        `Lưu đơn hàng thành công! Tổng: ${total.toLocaleString()}₫`,
      );
      setOrderItems([]);
      handleClearSearch();
      giftDrinks.clear();
      setDiscountPercent(0);
      setDiscountCode("");
      setVoucherCode("");
      setVoucherInfo(null);
      setVoucherError("");
      setVoucherDiscount(0);
      setUsePoint("");
      resetCashGiven();
      setChange(0);
      setCashDiscount(0);
      setCustomerInfo(null);
      setCustomerPhone("");
      setBusinessPhone("");
      setBusinessEmail("");
      setVerifiedBusinessTaxCode("");
      setShowNewCustomerForm(false);
      setNewCustomerName("");
      setNewCustomerAddress("");
      setNewCustomerTaxCode("");
      localStorage.removeItem("currentCustomerInfo");
      localStorage.removeItem("currentCustomerUsePoint");
      setIsGrabFoodyMode(false);
      setPaymentMethod(null);
      completeCustomerSale(IDCH);
      return true;
    } catch (err) {
      toast.error(
        "Có lỗi khi lưu hóa đơn: " +
          (err.response?.data?.message || err.message),
      );
      return false;
    }
  };

  const handleCheckoutSafe = async () => {
    // ✅ Check cả state và ref
    try {
      const isSuccess = await runCheckout(handleCheckout);
      if (isSuccess) {
        handleCloseConfirmModal();
      }
    } catch (error) {
      console.error("Checkout error:", error);
    }
  };

  const handleMobileQuickCheckout = async () => {
    if (orderItems.length === 0) return;

    if (isGrabFoodyMode) {
      toast.info("Vui lòng dùng màn hình chi tiết để chọn Grab/Shopee.");
      handleOpenConfirmModal();
      return;
    }

    if (!paymentMethod || !["cash", "transfer"].includes(paymentMethod)) {
      toast.warning("Vui lòng chọn Tiền mặt hoặc Chuyển khoản.");
      return;
    }

    if (localStorage.getItem("LoaiCH") === "0") {
      toast.info("Vui lòng vào chi tiết thanh toán để chọn số bàn.");
      handleOpenConfirmModal();
      return;
    }

    if (paymentMethod === "cash" && parseInt(cashGiven || "0", 10) < total) {
      autofillCashGiven();
      toast.info("Đã tự điền đủ tiền khách đưa. Bấm lại để xác nhận nhanh.");
      return;
    }

    try {
      const isSuccess = await runCheckout(handleCheckout);
      if (isSuccess) {
        setShowCartModal(false);
        handleCloseConfirmModal();
      }
    } catch (error) {
      console.error("Mobile quick checkout error:", error);
    }
  };

  handleCheckoutSafeRef.current = handleCheckoutSafe;

  // Thêm hàm xóa toàn bộ giỏ hàng
  const handleClearCart = () => {
    if (orderItems.length === 0) return;
    if (window.confirm("Bạn có chắc muốn xóa toàn bộ giỏ hàng?")) {
      setOrderItems([]);
      setDiscountPercent(0);
      setDiscountCode("");
    }
  };

  // Refs for drag scroll
  const categoriesListRef = React.useRef(null);
  const productsGridRef = React.useRef(null);

  useDragScroll(categoriesListRef);
  useDragScroll(productsGridRef);

  // Khi tìm ra khách hàng, nếu có điểm tiêu trước đó thì load vào state
  useEffect(() => {
    if (customerInfo) {
      const saved = localStorage.getItem("currentCustomerUsePoint");
      setUsePoint(saved || "");
    } else {
      setUsePoint("");
      localStorage.removeItem("currentCustomerUsePoint");
    }
  }, [customerInfo]);

  // Handler áp dụng điểm tiêu
  const handleApplyUsePoint = () => {
    const usePointValue = Math.max(0, Math.floor(Number(usePoint) || 0));
    const diemHienTai = parseInt(customerInfo?.DiemTichLuy, 10) || 0;
    const subtotal = orderItems.reduce(
      (sum, item) => sum + getItemLineTotal(item),
      0,
    );
    const discountAmount = subtotal * (discountPercent / 100);
    const membershipDiscountAmountLocal =
      subtotal * (membershipDiscountPercent / 100);
    const maxPoint = Math.floor(
      Math.max(
        subtotal -
          discountAmount -
          membershipDiscountAmountLocal -
          voucherDiscount -
          cashDiscount,
        0,
      ),
    );

    if (usePointValue < 0) {
      toast.error("Không được nhập số âm!");
      setUsePoint("");
      return;
    }
    if (usePointValue > diemHienTai) {
      toast.error("Không được nhập số điểm lớn hơn điểm hiện tại của khách!");
      setUsePoint(diemHienTai.toString());
      return;
    }
    if (usePointValue > maxPoint) {
      toast.error("Không được nhập số điểm lớn hơn tổng tiền hóa đơn!");
      setUsePoint(maxPoint.toString());
      return;
    }
    localStorage.setItem("currentCustomerUsePoint", usePointValue.toString());
    toast.success("Đã lưu điểm tiêu cho khách hàng!");
  };

  // Handler for searching products
  const searchRequestRef = React.useRef(0);
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!searchTerm.trim()) {
      setIsSearchMode(false);
      return;
    }

    const requestId = ++searchRequestRef.current;
    const isCurrentSearch = () => requestId === searchRequestRef.current;
    let localResults = [];

    try {
      setLoading((prev) => ({ ...prev, search: true }));
      setIsSearchMode(true);

      const searchValue = searchTerm.trim();
      setSubmittedSearchTerm(searchValue);
      setSearchTerm("");
      const loSXSearch = extractLoSXFromLoSearch(searchValue);

      if (loSXSearch) {
        const response = await axios.get(`${POS_API_BASE_URL}/api/QRTrungThu`, {
          params: { LoSX: loSXSearch },
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        const qrItems = Array.isArray(response.data)
          ? response.data
          : response.data
            ? [response.data]
            : [];

        if (!isCurrentSearch()) return;
        setSearchResults(
          qrItems.map((item) => buildTrungThuQRProduct(item, loSXSearch)),
        );
        return;
      }

      // Like the desktop POS: search the catalog saved in this browser first
      // (store prices, no network), ranked by name start, initials, words, then
      // code. Show those at once, then add API matches the browser does not
      // have yet (categories never opened, barcodes, server-side aliases).
      const cachedProducts = await getAllCachedProducts(productCacheScope).catch(() => []);
      localResults = findProductSuggestions(cachedProducts, searchValue, LOCAL_SEARCH_LIMIT, { desktop: true });
      if (!isCurrentSearch()) return;
      if (localResults.length) {
        setSearchResults(localResults);
        setLoading((prev) => ({ ...prev, search: false }));
      }

      // Lấy LoaiCH và IDCH từ localStorage
      const loaiCH = localStorage.getItem("LoaiCH");
      const IDCH = localStorage.getItem("IDCH");

      // Kiểm tra IDCH cho API HCM
      if (loaiCH === "3" && !IDCH) {
        if (!localResults.length) toast.error("Không tìm thấy thông tin cửa hàng (IDCH)");
        return;
      }

      // Chọn API theo LoaiCH
      const apiUrl =
        loaiCH === "3"
          ? `${POS_API_BASE_URL}/items/search-hcm?searchTerm=${encodeURIComponent(
              searchValue,
            )}&IDCH=${encodeURIComponent(IDCH)}`
          : `${POS_API_BASE_URL}/items/search?searchTerm=${encodeURIComponent(
              searchValue,
            )}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (!isCurrentSearch()) return;

      const productsData = Array.isArray(response.data)
        ? response.data.map((item) => ({
            id: item.MaSP,
            name: item.Ten_SP,
            price: item.DonGia || 0,
            price2: item.DonGia2 || item.DonGia || 0,
            image: getCategoryImage(item.MaNLSP),
            unit: item.DVT_SP,
            vat: item.VAT_SP,
            category: item.MaNLSP,
            categoryId: item.MaNLSP,
          }))
        : [];
      setSearchResults(mergeProductSearchResults(
        localResults,
        sortDesktopProductSearchResults(productsData, searchValue),
      ));
    } catch (error) {
      if (!isCurrentSearch()) return;
      console.error("Error searching products:", error);
      // Keep the local matches when only the API call failed (offline).
      if (!localResults.length) {
        toast.error("Lỗi khi tìm kiếm sản phẩm");
        setSearchResults([]);
      }
    } finally {
      if (isCurrentSearch()) setLoading((prev) => ({ ...prev, search: false }));
    }
  };

  // Clear search
  const handleClearSearch = () => {
    setSearchTerm("");
    setSubmittedSearchTerm("");
    setIsSearchMode(false);
    setSearchResults([]);
  };

  const handleSyncProducts = async (signal, onProgress) => {
    const checkCanceled = () => {
      if (signal.aborted) throw new Error("Đã hủy đồng bộ.");
    };
    const storeId = localStorage.getItem("IDCH");
    if (!storeId) throw new Error("Không tìm thấy thông tin cửa hàng (IDCH).");
    const response = await axios.get(getCategoriesApiUrl(storeName), { signal });
    checkCanceled();
    if (!Array.isArray(response.data) || !response.data.length || response.data.some((item) => !item.MaNLSP)) {
      throw new Error("Danh mục sản phẩm không hợp lệ.");
    }
    const nextCategories = mapCategories(response.data);
    const nextProducts = {};
    onProgress({ percent: Math.round(100 / (nextCategories.length + 1)), detail: "Đã tải danh mục" });
    for (const [index, category] of nextCategories.entries()) {
      checkCanceled();
      const result = await axios.get(`${POS_API_BASE_URL}/api/san-pham?IDCH=${encodeURIComponent(storeId)}&MaNLSP=${encodeURIComponent(category.id)}`, { signal });
      checkCanceled();
      if (!Array.isArray(result.data)) throw new Error(`Danh sách sản phẩm ${category.name} không hợp lệ.`);
      const items = result.data.map((item) => ({
        ...mapCatalogProduct(item, category.id, category.name), image: getCategoryImage(category.id),
        price2: Number(item.DonGia2 || item.DonGia) || 0,
      }));
      await saveProductsToCache(productCacheScope, category.id, items);
      checkCanceled();
      nextProducts[category.id] = items;
      onProgress({ percent: Math.round(100 * (index + 2) / (nextCategories.length + 1)), detail: `Đã tải ${index + 1}/${nextCategories.length} nhóm hàng` });
    }
    await saveCategoriesToCache(productCacheScope, nextCategories);
    checkCanceled();
    productRequestIdRef.current += 1;
    setCategories(nextCategories);
    setProducts(nextProducts);
    setSelectedCategory((current) => nextCategories.some((item) => item.id === current) ? current : nextCategories[0].id);
    setProductsLoaded(true);
    setProductsSource("api");
    setProductsSyncError("");
    setProductsRefreshing(false);
    setLastProductsSync(new Date().toISOString());
    setLoading((current) => ({ ...current, products: false }));
  };

  // State cho modal ghi chú sản phẩm
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [noteModalItem, setNoteModalItem] = useState(null);
  const [noteInput, setNoteInput] = useState("");
  const [noteQtyInput, setNoteQtyInput] = useState(1);
  const [noteDiscountInput, setNoteDiscountInput] = useState("0");
  const [noteDiscountAmountInput, setNoteDiscountAmountInput] = useState("0");

  const formatNoteDiscountValue = (value, maxDecimals = 10) => {
    if (!Number.isFinite(value) || value <= 0) return "0";
    const factor = 10 ** maxDecimals;
    const truncatedValue = Math.floor(value * factor) / factor;
    return truncatedValue.toFixed(maxDecimals).replace(/\.?0+$/, "");
  };

  const getNoteModalLineTotal = (item, quantity) => {
    if (!item) return 0;
    const unitPrice = Number(item.price) || 0;
    const qty = Math.max(0, Number(quantity) || 0);
    return unitPrice * qty;
  };

  const getNoteDiscountAmountFromPercent = (item, quantity, percentValue) => {
    const lineTotal = getNoteModalLineTotal(item, quantity);
    const percent = Math.max(0, Math.min(100, Number(percentValue) || 0));
    return formatNoteDiscountValue((lineTotal * percent) / 100, 2);
  };

  const getNoteDiscountPercentFromAmount = (item, quantity, amountValue) => {
    const lineTotal = getNoteModalLineTotal(item, quantity);
    const amount = Math.max(0, Number(amountValue) || 0);

    if (lineTotal <= 0) return "0";

    return formatNoteDiscountValue(
      (Math.min(amount, lineTotal) / lineTotal) * 100,
      10,
    );
  };

  const handleNoteQtyInputChange = (value) => {
    setNoteQtyInput(value);
    setNoteDiscountAmountInput(
      getNoteDiscountAmountFromPercent(noteModalItem, value, noteDiscountInput),
    );
  };

  const handleNoteDiscountPercentChange = (value) => {
    setNoteDiscountInput(value);
    setNoteDiscountAmountInput(
      getNoteDiscountAmountFromPercent(noteModalItem, noteQtyInput, value),
    );
  };

  const handleNoteDiscountAmountChange = (value) => {
    setNoteDiscountAmountInput(value);
    setNoteDiscountInput(
      value === ""
        ? "0"
        : getNoteDiscountPercentFromAmount(noteModalItem, noteQtyInput, value),
    );
  };
  // Mở modal ghi chú
  const handleOpenNoteModal = (item) => {
    const initialPercent = formatNoteDiscountValue(
      Number(item.KmaiPT) || 0,
      10,
    );
    setNoteModalItem(item);
    setNoteInput(item.note || "");
    setNoteQtyInput(item.quantity);
    setNoteDiscountInput(initialPercent);
    setNoteDiscountAmountInput(
      getNoteDiscountAmountFromPercent(item, item.quantity, initialPercent),
    );
    setShowNoteModal(true);
  };

  // Đóng modal ghi chú
  const handleCloseNoteModal = () => {
    setShowNoteModal(false);
    setNoteModalItem(null);
    setNoteInput("");
    setNoteQtyInput(1);
    setNoteDiscountInput("0");
    setNoteDiscountAmountInput("0");
  };

  // Lưu ghi chú và số lượng
  const handleSaveNoteModal = () => {
    if (!noteModalItem) return;

    const parsedKmaiPT = parseFloat(noteDiscountInput);
    if (isNaN(parsedKmaiPT) || parsedKmaiPT < 0 || parsedKmaiPT > 100) {
      toast.error("'% giảm giá món' phải từ 0 đến 100.");
      return;
    }

    const kmaiPT = parseFloat(
      formatNoteDiscountValue(Math.min(100, Math.max(0, parsedKmaiPT)), 10),
    );
    const modalItemKey = noteModalItem._uniqueId || noteModalItem.id;

    setOrderItems((prev) =>
      prev.map((item) =>
        (item._uniqueId || item.id) === modalItemKey
          ? {
              ...item,
              note: noteInput,
              quantity: normalizeSaleQuantity(noteQtyInput),
              KmaiPT: kmaiPT,
            }
          : item,
      ),
    );
    handleCloseNoteModal();
  };

  const noteModalLineTotal = getNoteModalLineTotal(noteModalItem, noteQtyInput);

  // Add dropdown menu state
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAllCategories, setShowAllCategories] = useState(false);

  const handleCategoryPick = (categoryId) => {
    handleCategorySelect(categoryId);
    setShowAllCategories(false);
    // Bring the picked category into view in the horizontal strip.
    window.requestAnimationFrame(() => {
      const cards = categoriesListRef.current?.querySelectorAll("[data-category-id]") || [];
      Array.from(cards)
        .find((card) => card.dataset.categoryId === String(categoryId))
        ?.scrollIntoView?.({ block: "nearest", inline: "center", behavior: "smooth" });
    });
  };

  // Handler for ending shift
  const handleEndShift = async () => {
    const TenUser =
      localStorage.getItem("TenUser") || localStorage.getItem("MaNV");
    const MaCH = localStorage.getItem("IDCH");

    if (!TenUser || !MaCH) {
      toast.error("Không tìm thấy thông tin người dùng hoặc cửa hàng!");
      return;
    }

    // Show confirmation toast
    toast.info(
      <div>
        <p>Bạn có chắc muốn kết ca không?</p>
        <div style={{ marginTop: 10 }}>
          <button
            style={{
              background: "#28a745",
              color: "white",
              border: "none",
              padding: "5px 15px",
              borderRadius: "4px",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss();
              performEndShift(TenUser, MaCH);
            }}
          >
            Xác nhận
          </button>
          <button
            style={{
              background: "#6c757d",
              color: "white",
              border: "none",
              padding: "5px 15px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => toast.dismiss()}
          >
            Hủy
          </button>
        </div>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeButton: false,
        hideProgressBar: true,
      },
    );
  };

  // Perform the actual shift end API call
  const performEndShift = async (TenUser, MaCH) => {
    try {
      const response = await axios.post(
        `${POS_API_BASE_URL}/api/sale-ket-ca`,
        { TenUser: TenUser, MaCH: parseInt(MaCH, 10) },
        { headers: { "Content-Type": "application/json" } },
      );

      if (response.status === 200) {
        // Fetch shift summary from the reporting API using IDCH
        const summaryRes = await axios.get(
          `${POS_API_BASE_URL}/api/sale-tong-hop-ket-ca?idch=${encodeURIComponent(
            MaCH,
          )}`,
        );

        const shiftData = summaryRes.data; // Expected shape as sample response
        toast.success("Kết ca thành công!");
        setShiftSummaryData(shiftData);
        setShowShiftSummary(true);
        setShowDropdown(false);
      }
    } catch (error) {
      console.error("Error ending shift:", error);
      toast.error(
        "Lỗi khi kết ca: " + (error.response?.data?.message || error.message),
      );
    }
  };

  const fetchMonthlyRevenue = async (monthValue = monthlyRevenueMonth) => {
    const MaCH = localStorage.getItem("IDCH");

    if (!MaCH) {
      toast.error("Không tìm thấy thông tin cửa hàng!");
      return;
    }

    if (!monthValue) {
      toast.error("Vui lòng chọn tháng/năm cần tra cứu!");
      return;
    }

    const [year, month] = monthValue.split("-").map(Number);

    if (!month || !year) {
      toast.error("Tháng/năm không hợp lệ!");
      return;
    }

    setMonthlyRevenueLoading(true);

    try {
      const response = await axios.get(
        `${MONTHLY_REVENUE_API_BASE_URL}/api/sale-doanh-thu-thang`,
        {
          params: {
            idch: MaCH,
            month,
            year,
          },
        },
      );

      setMonthlyRevenueData(response.data);
    } catch (error) {
      console.error("Error fetching monthly revenue:", error);
      toast.error(
        "Lỗi khi tra cứu doanh thu tháng: " +
          (error.response?.data?.message || error.message),
      );
    } finally {
      setMonthlyRevenueLoading(false);
    }
  };

  const handleOpenMonthlyRevenue = () => {
    setShowMonthlyRevenue(true);
    setShowDropdown(false);

    if (!monthlyRevenueData) {
      fetchMonthlyRevenue(monthlyRevenueMonth);
    }
  };

  const handleMonthlyRevenueSubmit = (event) => {
    event.preventDefault();
    fetchMonthlyRevenue(monthlyRevenueMonth);
  };

  const updateMonthlyRevenueDatePart = (field, value) => {
    const nextDateParts = {
      ...getMonthInputParts(monthlyRevenueMonth),
      [field]: value,
    };

    setMonthlyRevenueMonth(
      `${nextDateParts.year}-${String(nextDateParts.month).padStart(2, "0")}`,
    );
    setMonthlyRevenueData(null);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && !event.target.closest(".dropdown-menu-container")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  // Hàm mở trang nhập hàng
  const handleOpenNhapHangPage = () => {
    navigate("/nhap-hang");
  };

  // Hàm logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("LoaiCH");
    localStorage.removeItem("IDCH");
    localStorage.removeItem("MaNV");
    localStorage.removeItem("TenUser");
    localStorage.removeItem("TenCuaHang");
    localStorage.removeItem("currentCustomerInfo");
    localStorage.removeItem("currentCustomerUsePoint");
    // Xóa thêm các thông tin khác nếu cần
    navigate("/logOut");
  };

  // Handler for print toggle
  const handleTogglePrint = () => {
    const nextValue = !isPrintEnabled;
    setIsPrintEnabled(nextValue);
    if (!saveOrderPrintSettings({ isPrintEnabled: nextValue, isDisablePrintAPI })) {
      toast.warning("Không lưu được cài đặt in trên trình duyệt. Lựa chọn chỉ áp dụng cho phiên hiện tại.");
    }
  };

  // Handler for disable print API toggle
  const handleToggleDisablePrintAPI = () => {
    const nextValue = !isDisablePrintAPI;
    setIsDisablePrintAPI(nextValue);
    if (!saveOrderPrintSettings({ isPrintEnabled, isDisablePrintAPI: nextValue })) {
      toast.warning("Không lưu được cài đặt in trên trình duyệt. Lựa chọn chỉ áp dụng cho phiên hiện tại.");
    }
  };

  // Add promotions state
  const [showPromotionsModal, setShowPromotionsModal] = useState(false);
  const promotions = giftDrinks.availablePromotions;
  const loadingPromotions = giftDrinks.loading;

  // Filter for Bánh mì có nhân; null shows all products.
  const [banhMiFilter, setBanhMiFilter] = useState(null);
  useEffect(() => {
    const loaiCH = localStorage.getItem("LoaiCH");
    if (loaiCH === "3") {
      if (isGrabFoodyMode) {
        setDiscountPercent(19.23);
        setDiscountCode("19.23");
      } else {
        // Chỉ hoàn lại nếu trước đó tự áp 19.23%
        setDiscountPercent((prev) => (prev === 19.23 ? 0 : prev));
        setDiscountCode((prev) => (prev === "19.23" ? "" : prev));
      }
    }
  }, [isGrabFoodyMode]);

  // Add function to open promotions modal
  const handleOpenPromotionsModal = () => {
    setShowPrintSettings(false);
    setShowPromotionsModal(true);
  };

  // Add function to handle promotion selection
  const handleSelectPromotion = (maUD) => {
    setShowPromotionsModal(false);
    navigate(`/uu-dai-ct?Ma=${maUD}`);
  };


  // Helper to detect Bánh mì có nhân (MaNLSP = BMCN)
  const isBanhMiCoNhanCategory = selectedCategory === "BMCN2";

  // Filter products by Bánh mì/Hamburger when in BMCN
  const filterBanhMiHamburger = (list = []) => {
    if (!isBanhMiCoNhanCategory || !banhMiFilter) return list;
    return list.filter((p) => {
      const lower = (p.name || "").toLowerCase();
      if (banhMiFilter === "banhmi")
        return lower.includes("bánh mì") || lower.includes("bánh mỳ");
      if (banhMiFilter === "hamburger")
        return lower.includes("hamburger") || lower.includes("hambuger");
      return true;
    });
  };

  return (
    <div className="order-page">
      <BreadAddonModal item={addonItem} orderItems={orderItems} deliveryMode={isGrabFoodyMode}
        apiBase={POS_API_BASE_URL} storeId={localStorage.getItem("IDCH")}
        onClose={() => setAddonItem(null)}
        onSave={(selections) => {
          setOrderItems((items) => applyBreadAddons(items, addonItem._uniqueId || addonItem.id, selections));
          setAddonItem(null); toast.success("Đã cập nhật đồ ăn kèm.");
        }}
        onEditNote={() => { handleOpenNoteModal(addonItem); setAddonItem(null); }} />
      {showConfirmModal && showPaymentQRZoom && paymentQRCodeSrc && createPortal(
        <div className="order-payment-qr-overlay" onClick={() => setShowPaymentQRZoom(false)}>
          <div className="order-payment-qr-zoom" role="dialog" aria-modal="true"
            aria-label="Mã QR thanh toán phóng to" onClick={(event) => event.stopPropagation()}>
            <button type="button" className="order-payment-qr-close" autoFocus
              aria-label="Đóng mã QR phóng to" onClick={() => setShowPaymentQRZoom(false)}>×</button>
            <img src={paymentQRCodeSrc} alt="QR Code thanh toán phóng to" />
          </div>
        </div>,
        document.body,
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* Promotions Modal */}
      <Modal
        show={showPromotionsModal}
        onHide={() => setShowPromotionsModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>🎁 Danh sách ưu đãi</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {loadingPromotions ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Đang tải...</span>
              </div>
            </div>
          ) : promotions.length === 0 ? (
            <div className="text-center py-4 text-muted">
              Hiện tại chưa có ưu đãi nào
            </div>
          ) : (
            <div className="list-group">
              {promotions.map((promo) => (
                <button
                  key={promo.MaUD}
                  className="list-group-item list-group-item-action"
                  onClick={() => handleSelectPromotion(promo.MaUD)}
                  style={{
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                    e.currentTarget.style.transform = "translateX(5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  <div className="d-flex w-100 justify-content-between align-items-start">
                    <h5
                      className="mb-1"
                      style={{ color: "#d4703e", fontWeight: "bold" }}
                    >
                      {promo.TenUD}
                    </h5>
                    <span
                      className={`badge ${
                        promo.Act_UD ? "bg-success" : "bg-secondary"
                      }`}
                    >
                      {promo.Act_UD ? "Đang áp dụng" : "Không áp dụng"}
                    </span>
                  </div>
                  <div className="mb-2">
                    <small className="text-muted">
                      <i className="fas fa-calendar-alt me-1"></i>
                      Từ{" "}
                      {new Date(promo.NgayBatDau).toLocaleDateString(
                        "vi-VN",
                      )} -{" "}
                      {new Date(promo.NgayKetThuc).toLocaleDateString("vi-VN")}
                    </small>
                  </div>
                  {promo.items && promo.items.length > 0 && (
                    <div>
                      <small className="text-muted">
                        <i className="fas fa-box me-1"></i>
                        Áp dụng cho {promo.items.length} sản phẩm
                      </small>
                    </div>
                  )}
                  {(promo.GiamGia > 0 || promo.GiaBan > 0) && (
                    <div className="mt-2">
                      {promo.GiaBan > 0 && (
                        <span className="badge bg-primary">
                          Giá: {promo.GiaBan.toLocaleString()}₫
                        </span>
                      )}
                    </div>
                  )}
                </button>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowPromotionsModal(false)}
          >
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>

      {/* QR Scanner Modal */}
      <Modal
        show={showQRScanner}
        onHide={handleCloseQRScanner}
        centered
        size="md"
        dialogClassName="qr-scanner-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bán bánh trung thu (QR)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="qr-scanner-camera">
            <video
              ref={qrVideoRef}
              className="qr-scanner-video"
              autoPlay
              playsInline
              muted
            />
            <canvas ref={qrCanvasRef} className="qr-scanner-canvas" />
            <div className="qr-scanner-frame" />
          </div>

          {qrCameraError && (
            <div className="alert alert-warning py-2 mt-3 mb-0">
              {qrCameraError}
            </div>
          )}

          <div className="mt-3">
            <label className="form-label fw-semibold" htmlFor="qrManualInput">
              Nhập mã QR hoặc LoSX
            </label>
            <div className="input-group">
              <input
                id="qrManualInput"
                className="form-control"
                value={qrManualInput}
                onChange={(event) => setQrManualInput(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    handleQRManualSubmit();
                  }
                }}
                placeholder="https://doticom.vn/t.php?c=592"
                autoFocus
              />
              <Button
                variant="primary"
                onClick={handleQRManualSubmit}
                disabled={qrProcessing}
              >
                {qrProcessing ? "Đang thêm..." : "Thêm"}
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseQRScanner}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toàn bộ danh mục */}
      <Modal
        show={showAllCategories}
        onHide={() => setShowAllCategories(false)}
        centered
        scrollable
        dialogClassName="all-categories-modal"
        aria-labelledby="all-categories-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="all-categories-title">Danh mục</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="all-categories-grid">
            {categories.map((category) => (
              <button
                key={category.id}
                type="button"
                className={`all-categories-item${selectedCategory === category.id ? " active" : ""}`}
                aria-pressed={selectedCategory === category.id}
                onClick={() => handleCategoryPick(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </Modal.Body>
      </Modal>

      {/* Dropdown Menu */}
      <div className="dropdown-menu-container">
        <button
          className={`dropdown-toggle-btn${isGrabFoodyMode ? " grab-foody-on" : ""}`}
          onClick={() => setShowDropdown(!showDropdown)}
          title={isGrabFoodyMode ? "Menu chức năng (đang bật Grab & Foody)" : "Menu chức năng"}
        >
          ⚙️
          {isGrabFoodyMode && <span className="grab-foody-badge">Grab</span>}
        </button>
        <div
          className={`dropdown-menu-custom ${showDropdown ? "show" : "hide"}`}
        >
          {localStorage.getItem("TenCuaHang") && (
            <div className="dropdown-store-name">
              {localStorage.getItem("TenCuaHang")}
            </div>
          )}
          <button
            type="button"
            role="switch"
            aria-checked={isGrabFoodyMode}
            className={`dropdown-item-custom grab-foody-toggle${isGrabFoodyMode ? " on" : ""}`}
            onClick={() => {
              setIsGrabFoodyMode((current) => !current);
              setShowDropdown(false);
            }}
          >
            <i className="fas fa-motorcycle" style={{ color: "#28a745" }} aria-hidden="true"></i>
            Grab & Foody
            <span className="grab-foody-switch" aria-hidden="true" />
          </button>
          <OrderSync scope={productCacheScope} onSync={handleSyncProducts} onStart={() => setShowDropdown(false)} />
          <button
            className="dropdown-item-custom"
            onClick={() => window.open("/admin", "_blank")}
          >
            <i className="fas fa-clock" style={{ color: "#d4703e" }}></i>
            Quản trị
          </button>
          {/* 
          <button
            className="dropdown-item-custom"
            onClick={handleOpenNhapHangPage}
          >
            <i className="fas fa-clock" style={{ color: "#d4703e" }}></i>
            Nhập hàng
          </button>
          */}
          <button className="dropdown-item-custom" onClick={handleEndShift}>
            <i className="fas fa-clock" style={{ color: "#d4703e" }}></i>
            Kết Ca
          </button>
          <button
            className="dropdown-item-custom"
            onClick={handleOpenMonthlyRevenue}
          >
            <i
              className="fas fa-calendar-alt"
              style={{ color: "#d4703e" }}
            ></i>
            Doanh thu tháng
          </button>
          <button
            className="dropdown-item-custom"
            onClick={handleOpenQRScanner}
            disabled={qrProcessing}
          >
            <i className="fas fa-qrcode" style={{ color: "#d4703e" }}></i>
            Quét mã QR
          </button>
          <button
            type="button"
            className="dropdown-item-custom"
            onClick={() => {
              setShowDropdown(false);
              setShowPrintSettings(true);
            }}
          >
            <i className="fas fa-print" style={{ color: "#d4703e" }} aria-hidden="true" />
            Cài đặt in
          </button>
          <button className="dropdown-item-custom" onClick={handleLogout}>
            <i className="fas fa-clock" style={{ color: "#d4703e" }}></i>
            Đăng Xuất
          </button>
        </div>
      </div>

      {/* Shift Summary Modal */}
      <ShiftSummaryModal
        show={showShiftSummary}
        onClose={() => setShowShiftSummary(false)}
        data={shiftSummaryData}
      />

      <ShiftSummaryModal
        show={showMonthlyRevenue}
        onClose={() => setShowMonthlyRevenue(false)}
        data={monthlyRevenueData}
        title="📊 Doanh thu tháng"
        totalLabel="Doanh thu tháng"
        printTitle="Báo Cáo Doanh Thu Tháng"
        emptyMessage="Chọn tháng/năm rồi bấm Tra Cứu để xem doanh thu."
        isLoading={monthlyRevenueLoading}
        filterControls={
          <form
            className="monthly-revenue-filter bg-white rounded-3 shadow-sm p-3 mb-3"
            onSubmit={handleMonthlyRevenueSubmit}
          >
            <div className="d-flex flex-column flex-sm-row gap-2 align-items-sm-end">
              <div className="flex-grow-1">
                <label
                  className="form-label mb-1"
                  htmlFor="monthly-revenue-month"
                >
                  Tháng
                </label>
                <select
                  id="monthly-revenue-month"
                  className="form-control"
                  value={monthlyRevenueDateParts.month}
                  onChange={(event) => {
                    updateMonthlyRevenueDatePart("month", event.target.value);
                  }}
                  disabled={monthlyRevenueLoading}
                >
                  {MONTH_SELECT_OPTIONS.map((month) => (
                    <option key={month} value={month}>
                      Tháng {Number(month)}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex-grow-1">
                <label
                  className="form-label mb-1"
                  htmlFor="monthly-revenue-year"
                >
                  Năm
                </label>
                <input
                  id="monthly-revenue-year"
                  className="form-control"
                  type="number"
                  inputMode="numeric"
                  min="2000"
                  max="2100"
                  value={monthlyRevenueDateParts.year}
                  onChange={(event) => {
                    updateMonthlyRevenueDatePart("year", event.target.value);
                  }}
                  disabled={monthlyRevenueLoading}
                />
              </div>
              <Button type="submit" disabled={monthlyRevenueLoading}>
                {monthlyRevenueLoading ? "Đang tra cứu..." : "Tra Cứu"}
              </Button>
            </div>
          </form>
        }
      />

      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-8 products-section"
            style={{ paddingTop: "12px", paddingBottom: "12px" }}
          >
            {process.env.NODE_ENV !== "production" && debug.error && (
              <div className="alert alert-danger">
                <h5>Lỗi API:</h5>
                <pre>{debug.error}</pre>
              </div>
            )}

            <div className="search-container mb-0">
              <div className="search-wrapper">
                <CachedProductSearch
                  cacheScope={productCacheScope}
                  cacheVersion={products}
                  value={searchTerm}
                  onChange={setSearchTerm}
                  onClear={handleClearSearch}
                  onSubmit={handleSearch}
                  onSelect={(product) => {
                    handleAddToOrder(product);
                    handleClearSearch();
                  }}
                  isSearching={loading.search}
                  isGrabFoodyMode={isGrabFoodyMode}
                />
                {isSearchMode && (
                  <div className="search-status">
                    <span className="search-results-count">
                      {searchResults.length > 0
                        ? `Tìm thấy ${searchResults.length} sản phẩm`
                        : "Không tìm thấy sản phẩm nào"}
                    </span>
                    <button
                      className="btn-back-to-categories"
                      onClick={handleClearSearch}
                    >
                      <i className="fas fa-arrow-left me-1"></i>
                      Quay lại danh mục
                    </button>
                  </div>
                )}
              </div>
            </div>
            {/* Danh mục */}
            {!isSearchMode && (
              <div className="categories-container">
                {loading.categories ? (
                  <div className="loading-indicator">Đang tải danh mục...</div>
                ) : categories.length > 0 ? (
                  <div className="categories-bar">
                  <div className="categories-list" ref={categoriesListRef}>
                    {categories.map((category) => (
                      <div
                        key={category.id}
                        data-category-id={category.id}
                        className={`category-card ${
                          selectedCategory === category.id ? "active" : ""
                        }`}
                        onClick={() => handleCategorySelect(category.id)}
                      >
                        {/* 
                        <div className="category-img-container">
                          <img src={category.image} alt={category.name} />
                        </div>
                        */}
                        <div className="category-name" title={category.name}>
                          {category.name}
                        </div>
                      </div>
                    ))}
                  </div>
                  <button
                    type="button"
                    className="categories-more-btn"
                    onClick={() => setShowAllCategories(true)}
                    aria-haspopup="dialog"
                  >
                    <i className="fas fa-th-large" aria-hidden="true"></i>
                    Xem thêm
                  </button>
                  </div>
                ) : (
                  <div className="no-categories">
                    Không có danh mục nào. Vui lòng kiểm tra kết nối API.
                    {/* Debug raw response data */}
                    {process.env.NODE_ENV !== "production" &&
                      debug.categoriesResponse && (
                        <div className="mt-3">
                          <small>Phản hồi API gốc:</small>
                          <pre>
                            {JSON.stringify(debug.categoriesResponse, null, 2)}
                          </pre>
                        </div>
                      )}
                  </div>
                )}
              </div>
            )}

            {/* Sản phẩm */}
            <div
              className="products-container"
              style={{
                position: "relative",
                minHeight: "80vh",
                paddingBottom: "10px",
              }}
            >
              <div className="order-product-toolbar">
                {isBanhMiCoNhanCategory && (
                  <div className="order-product-filters" role="group" aria-label="Lọc bánh mì và hamburger"
                    onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") event.stopPropagation(); }}>
                    {[
                      { value: null, label: "Tất cả" },
                      { value: "banhmi", label: "Bánh mì" },
                      { value: "hamburger", label: "Hamburger" },
                    ].map((filter) => (
                      <button
                        key={filter.label}
                        type="button"
                        className={`order-product-filter${banhMiFilter === filter.value ? " active" : ""}`}
                        aria-pressed={banhMiFilter === filter.value}
                        onClick={() => setBanhMiFilter(filter.value)}
                      >
                        {filter.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {isSearchMode ? (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>Kết quả tìm kiếm: "{submittedSearchTerm}"</h3>
                  </div>
                  {loading.search ? (
                    <div className="loading-indicator">Đang tìm kiếm...</div>
                  ) : searchResults.length > 0 ? (
                    <div
                      className="products-grid"
                      style={{
                        height: "100%",
                      }}
                      ref={productsGridRef}
                    >
                      {searchResults.map((product) => (
                        <div
                          key={product.id}
                          className="product-card"
                          onClick={(e) => handleProductCardClick(product, e)}
                          style={{
                            cursor: "pointer",
                            border: isGrabFoodyMode
                              ? "3px solid #28a745"
                              : "1px solid #dee2e6",
                            boxShadow: isGrabFoodyMode
                              ? "0 0 10px rgba(40, 167, 69, 0.3)"
                              : "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          <div className="product-details">
                            <h4>{product.name}</h4>
                            {/*  <p className="unit">{product.unit}</p>*/}
                            <p className="price">
                              {(isGrabFoodyMode
                                ? product.price2
                                : product.price
                              ).toLocaleString()}
                              ₫
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-products">
                      Không tìm thấy sản phẩm nào phù hợp.
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="products-heading">
                    {productsLoaded && productsRefreshing && (
                      <div
                        className="product-sync-status text-muted small"
                        role="status"
                        aria-live="polite"
                        title={
                          "Nguồn dữ liệu: " +
                          (productsSource || "cache") +
                          (lastProductsSync
                            ? " - đồng bộ lúc " +
                              new Date(lastProductsSync).toLocaleTimeString()
                            : "")
                        }
                      >
                        <span className="spinner-border spinner-border-sm" aria-hidden="true" />
                        Đang đồng bộ dữ liệu sản phẩm...
                      </div>
                    )}
                  </div>
                  {!productsLoaded && loading.products ? (
                    <div className="loading-indicator">
                      Đang tải sản phẩm...
                    </div>
                  ) : products[selectedCategory] &&
                    filterBanhMiHamburger(products[selectedCategory]).length >
                      0 ? (
                    <div className="products-grid" ref={productsGridRef}>
                      {filterBanhMiHamburger(products[selectedCategory]).map(
                        (product) => (
                          <div
                            key={product.id}
                            className="product-card"
                            onClick={(e) => handleProductCardClick(product, e)}
                            style={{
                              cursor: "pointer",
                              border: isGrabFoodyMode
                                ? "3px solid #28a745"
                                : "1px solid #dee2e6",
                              boxShadow: isGrabFoodyMode
                                ? "0 0 10px rgba(40, 167, 69, 0.3)"
                                : "0 2px 4px rgba(0,0,0,0.1)",
                            }}
                          >
                            <div className="product-details">
                              <h4>{product.name}</h4>
                              {/* <p className="unit">{product.unit}</p>*/}
                              <p className="price">
                                {(isGrabFoodyMode
                                  ? product.price2
                                  : product.price
                                ).toLocaleString()}
                                ₫
                              </p>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  ) : productsSyncError ? (
                    <div className="no-products">
                      <p>{productsSyncError}</p>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() =>
                          setProductsRefreshKey((currentKey) => currentKey + 1)
                        }
                      >
                        Thử lại
                      </button>
                    </div>
                  ) : (
                    <div className="no-products">
                      Không có sản phẩm nào trong danh mục này.
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Bên phải - Tóm tắt đơn hàng */}
          <div
            className="col-md-4 order-section d-none d-md-block"
            style={{ paddingBottom: "0px" }}
          >
            <div className="order-summary">
              {/* Modal xác nhận thanh toán */}
              <Modal
                show={showConfirmModal}
                enforceFocus={!showPaymentQRZoom}
                onHide={handleCloseConfirmModal}
                centered
                dialogClassName="modal-center-custom checkout-confirm-modal"
                style={{ border: "1px solid #28a745" }}
              >
                <Modal.Header closeButton>
                  <div className="w-100 text-center">
                    {/* Nếu LoaiCH === "0" thì hiển thị chọn bàn */}
                    {localStorage.getItem("LoaiCH") === "0" && (
                      <div className="mb-2">
                        <h5 className="mb-0">Chọn số bàn</h5>
                        <div className="d-flex justify-content-center align-items-center mb-2">
                          <button
                            className="btn btn-outline-secondary me-2 rounded-circle"
                            style={{ width: 48, height: 48 }}
                            onClick={() =>
                              setTablePage((p) => Math.max(0, p - 1))
                            }
                            disabled={tablePage === 0}
                          >
                            &lt;
                          </button>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {Array.from(
                              { length: TABLES_PER_PAGE },
                              (_, i) => tablePage * TABLES_PER_PAGE + i + 1,
                            )
                              .filter((num) => num <= TOTAL_TABLES)
                              .map((num) => (
                                <button
                                  key={num}
                                  className={`btn ${
                                    selectedTable === num
                                      ? "btn-success"
                                      : "btn-outline-success"
                                  } rounded-circle`}
                                  style={{ width: 48, height: 48, margin: 4 }}
                                  onClick={() => setSelectedTable(num)}
                                >
                                  {num}
                                </button>
                              ))}
                          </div>
                          <button
                            className="btn btn-outline-secondary ms-2 rounded-circle"
                            style={{ width: 48, height: 48 }}
                            onClick={() =>
                              setTablePage((p) =>
                                Math.min(totalTablePages - 1, p + 1),
                              )
                            }
                            disabled={tablePage >= totalTablePages - 1}
                          >
                            &gt;
                          </button>
                        </div>
                      </div>
                    )}
                    {/* Nếu không phải Grab & Foody thì hiển thị tiêu đề xác nhận thanh toán */}
                    {!isGrabFoodyMode && (
                      <>
                        <div className="d-flex justify-content-center mb-2">
                          <h5 className="mb-0">Xác nhận thanh toán</h5>
                        </div>
                        {/* Table selection UI removed (đã thay bằng đoạn trên) */}
                      </>
                    )}
                    {isGrabFoodyMode && (
                      <div className="d-flex justify-content-center mb-2">
                        <h5 className="mb-0">Xác nhận đơn hàng Grab & Foody</h5>
                      </div>
                    )}
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="row">
                    {/* Bên trái: Chọn phương thức thanh toán */}
                    <div
                      className="col-md-5 mb-3 d-flex flex-column align-items-center"
                      style={{ maxWidth: 350 }}
                    >
                      <label style={{ fontWeight: "bold" }}>
                        Phương thức thanh toán
                      </label>
                      <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
                        {!isGrabFoodyMode && (
                          <>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "cash"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              } checkout-method-btn`}
                              onClick={() => {
                                setPaymentMethod("cash");
                              }}
                            >
                              Tiền mặt
                            </button>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "transfer"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              } checkout-method-btn`}
                              onClick={() => setPaymentMethod("transfer")}
                            >
                              Chuyển khoản
                            </button>
                            {/*
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "card"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("card")}
                            >
                              Quẹt thẻ
                            </button>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "momo"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("momo")}
                            >
                              Ví Momo
                            </button>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "vnpay"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("vnpay")}
                            >
                              Ví Vnpay
                            </button>
                            
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "notPaid"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("notPaid")}
                            >
                              Nợ
                            </button>
                            */}
                            {/* Grab & Shopee buttons are hidden when !isGrabFoodyMode */}
                          </>
                        )}
                        {isGrabFoodyMode && (
                          <>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "grab"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("grab")}
                            >
                              Grab
                            </button>
                            <button
                              className={`btn btn-sm ${
                                paymentMethod === "shopee"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                              }`}
                              onClick={() => setPaymentMethod("shopee")}
                            >
                              Shopee
                            </button>
                          </>
                        )}
                      </div>

                      {paymentMethod === "cash" && !isGrabFoodyMode && (
                        <>
                          <label style={{ fontWeight: "bold" }}>
                            Tiền khách đưa
                          </label>
                          <div
                            className="input-group mb-2"
                            style={{ maxWidth: 260 }}
                          >
                            <input
                              type="text"
                              className="form-control checkout-cash-input"
                              // The on-screen keypad below enters the amount;
                              // keep the phone keyboard from covering it.
                              inputMode={isTouchDevice ? "none" : "numeric"}
                              value={cashGiven}
                              onChange={(e) =>
                                handleCashGivenChange(e.target.value)
                              }
                              onFocus={(e) => {
                                if (isCashGivenAutofilled) {
                                  e.target.select();
                                }
                              }}
                              style={{
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: "1.2em",
                              }}
                              placeholder="0"
                            />
                          </div>
                          <div
                            className="cash-keypad"
                          >
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, "000", 0, "C"].map(
                              (val, idx) => (
                                <button
                                  key={idx}
                                  className="btn btn-outline-secondary m-1 cash-key-btn"
                                  onClick={() =>
                                    handleCustomKeyboardClick(
                                      val === "C" ? "C" : val.toString(),
                                    )
                                  }
                                  type="button"
                                >
                                  {val === "C" ? "Xóa" : val}
                                </button>
                              ),
                            )}
                          </div>
                          <div className="mt-2 d-flex justify-content-between">
                            <span>
                              Tiền cần thối:{" "}
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color: change < 0 ? "red" : "green",
                                }}
                              >
                                {change <= 0
                                  ? "0₫"
                                  : change.toLocaleString() + "₫"}
                              </span>
                            </span>
                          </div>
                        </>
                      )}
                      {(paymentMethod === "transfer" ||
                        paymentMethod === "card" ||
                        paymentMethod === "momo" ||
                        paymentMethod === "vnpay" ||
                        paymentMethod === "grab" ||
                        paymentMethod === "shopee") && (
                        <div className="text-center">
                          <label style={{ fontWeight: "bold" }}>
                            {isGrabFoodyMode
                              ? "Đặt hàng qua ứng dụng"
                              : paymentMethod === "transfer"
                              ? "Quét mã QR để chuyển khoản"
                              : "Quét mã QR để thanh toán"}
                          </label>
                          <div className="mt-3">
                            {paymentQRCodeSrc && (
                              <button
                                type="button"
                                className="order-payment-qr-button"
                                onClick={() => setShowPaymentQRZoom(true)}
                                aria-label="Phóng to mã QR thanh toán"
                              >
                                <img
                                  ref={transferQRCodeRef}
                                  src={paymentQRCodeSrc}
                                  alt="QR Code thanh toán"
                                  style={{ width: "200px", height: "200px" }}
                                />
                              </button>
                            )}
                          </div>
                          {paymentMethod === "transfer" && paymentQRCodeSrc && (
                            <Button
                              type="button"
                              variant="outline-primary"
                              className="mt-2 border border-primary"
                              onClick={handlePrintTransferQR}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") event.stopPropagation();
                              }}
                            >
                              In mã QR
                            </Button>
                          )}
                          {/* Chọn thêm hình thức shiper giao dịch: Shiper chuyển khoản và shiper tiền mặt */}
                          {isGrabFoodyMode && (
                            <div className="mt-3">
                              <label style={{ fontWeight: "bold" }}>
                                Hình thức shiper giao dịch
                              </label>
                              <div className="d-flex gap-2 mt-2">
                                <button
                                  className={`btn btn-sm ${
                                    shipperPaymentMethod === "transfer"
                                      ? "btn-success"
                                      : "btn-secondary"
                                  }`}
                                  onClick={() =>
                                    setShipperPaymentMethod("transfer")
                                  }
                                >
                                  Chuyển khoản
                                </button>
                                <button
                                  className={`btn btn-sm ${
                                    shipperPaymentMethod === "cash"
                                      ? "btn-success"
                                      : "btn-secondary"
                                  }`}
                                  onClick={() =>
                                    setShipperPaymentMethod("cash")
                                  }
                                >
                                  Tiền mặt
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {/* Bên phải: Thông tin khách hàng, giảm giá, tổng kết */}
                    <div className="col-md-7" style={{ maxWidth: 650 }}>
                      {/* Phần nhập/thông tin khách hàng */}
                      <div className="mb-3 customer-section-orderpage">
                        <label
                          htmlFor="customerPhoneOrder"
                          className="form-label"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "bold",
                            color: "#333",
                          }}
                        >
                          Tìm khách hàng
                        </label>
                        <div className="input-group input-group-sm">
                          <select
                            className="form-select"
                            style={{ maxWidth: 90 }}
                            aria-label="Tìm khách hàng theo"
                            value={customerSearchType}
                            disabled={customerLoading}
                            onChange={(event) => {
                              setCustomerSearchType(event.target.value);
                              setCustomerInfo(null);
                              setShowNewCustomerForm(false);
                              setNewCustomerName("");
                              setNewCustomerAddress("");
                              setNewCustomerTaxCode("");
                              setBusinessPhone("");
                              setBusinessEmail("");
                              setVerifiedBusinessTaxCode("");
                              setUsePoint("");
                              localStorage.removeItem("currentCustomerInfo");
                              localStorage.removeItem("currentCustomerUsePoint");
                            }}
                          >
                            <option value="phone">SĐT</option>
                            <option value="taxCode">MST</option>
                          </select>
                          <input
                            type={customerSearchType === "taxCode" ? "text" : "tel"}
                            className="form-control"
                            id="customerPhoneOrder"
                            value={customerSearchType === "taxCode" ? newCustomerTaxCode : customerPhone}
                            onChange={(event) => {
                              if (customerSearchType === "taxCode") {
                                setNewCustomerTaxCode(event.target.value);
                                setVerifiedBusinessTaxCode("");
                                setCustomerInfo(null);
                                setNewCustomerName("");
                                setNewCustomerAddress("");
                                setShowNewCustomerForm(false);
                                setBusinessPhone("");
                                setBusinessEmail("");
                                setUsePoint("");
                                localStorage.removeItem("currentCustomerInfo");
                                localStorage.removeItem("currentCustomerUsePoint");
                              } else {
                                handlePhoneInputChange(event);
                              }
                            }}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                event.preventDefault();
                                event.stopPropagation();
                                handleSearchCustomer();
                              }
                            }}
                            placeholder={customerSearchType === "taxCode" ? "Nhập MST doanh nghiệp" : "Nhập SĐT"}
                            disabled={customerLoading}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={handleSearchCustomer}
                            disabled={customerLoading}
                          >
                            {customerLoading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              "Tìm"
                            )}
                          </button>
                        </div>
                        {customerInfo && (
                          <>
                            <div
                              className="mt-2 alert alert-success py-1 px-2"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {customerInfo.Membership === "1" ? (
                                <>
                                  NV: <b>{customerInfo.Ten}</b> - Điểm:{" "}
                                </>
                              ) : (
                                <>
                                  KH: <b>{customerInfo.Ten}</b> - Điểm:{" "}
                                </>
                              )}
                              {(() => {
                                const diemHienTai =
                                  parseInt(customerInfo.DiemTichLuy, 10) || 0;
                                const usePointValueInt = Math.floor(
                                  Number(usePoint) || 0,
                                );
                                // Chỉ trừ nếu điểm tiêu hợp lệ (không âm, không vượt quá điểm hiện tại)
                                if (
                                  usePointValueInt > 0 &&
                                  usePointValueInt <= diemHienTai
                                ) {
                                  return (
                                    diemHienTai - usePointValueInt
                                  ).toLocaleString();
                                }
                                return diemHienTai.toLocaleString();
                              })()}
                              <button
                                className="btn btn-sm btn-link text-danger py-0 px-1 float-end"
                                onClick={() => {
                                  setCustomerInfo(null);
                                  setCustomerPhone("");
                                  localStorage.removeItem(
                                    "currentCustomerInfo",
                                  );
                                  setShowNewCustomerForm(false);
                                }}
                                title="Xóa thông tin KH"
                                style={{ lineHeight: 1 }}
                              >
                                &times;
                              </button>
                            </div>
                            <div
                              className="input-group input-group-sm mb-2"
                              style={{ maxWidth: 220 }}
                            >
                              <input
                                type="number"
                                min="0"
                                className="form-control"
                                placeholder="Điểm tiêu"
                                value={usePoint}
                                onChange={(e) => setUsePoint(e.target.value)}
                              />
                              <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={handleApplyUsePoint}
                              >
                                Áp dụng
                              </button>
                            </div>
                          </>
                        )}
                        {customerSearchType === "taxCode" && verifiedBusinessTaxCode && newCustomerName && (
                          <>
                            <section
                              className="mt-2 p-3 border rounded bg-light"
                              aria-label="Thông tin xuất hóa đơn"
                            >
                              <h6 className="mb-2">Thông tin xuất hóa đơn</h6>
                              <dl className="mb-0 small">
                                <dt>Tên doanh nghiệp</dt>
                                <dd className="mb-2">{newCustomerName}</dd>
                                <dt>Địa chỉ</dt>
                                <dd className="mb-2">{newCustomerAddress || "—"}</dd>
                                <dt>MST</dt>
                                <dd className="mb-0">{verifiedBusinessTaxCode}</dd>
                              </dl>
                            </section>
                            <div className="mt-2">
                              <label
                                htmlFor="newCustomerPhoneOrder"
                                className="form-label small"
                              >
                                SĐT liên hệ (không bắt buộc)
                              </label>
                              <input
                                type="tel"
                                className="form-control form-control-sm"
                                id="newCustomerPhoneOrder"
                                value={businessPhone}
                                onChange={(event) => setBusinessPhone(event.target.value)}
                                disabled={customerLoading}
                              />
                            </div>
                            <div className="mt-2">
                              <label
                                htmlFor="businessEmailOrder"
                                className="form-label small"
                              >
                                Email (không bắt buộc)
                              </label>
                              <input
                                type="email"
                                className="form-control form-control-sm"
                                id="businessEmailOrder"
                                value={businessEmail}
                                onChange={(event) => setBusinessEmail(event.target.value)}
                                disabled={customerLoading}
                              />
                            </div>
                          </>
                        )}
                        {customerSearchType !== "taxCode" && showNewCustomerForm && !customerInfo && (
                          <form
                            onSubmit={handleCreateNewCustomer}
                            className="mt-2 p-2 border rounded bg-light"
                          >
                            <h6
                              style={{
                                fontSize: "0.9rem",
                                marginBottom: "0.5rem",
                              }}
                            >
                              Thêm khách hàng mới
                            </h6>
                            <div className="mb-1">
                              <label
                                htmlFor="newCustomerNameOrder"
                                className="form-label"
                                style={{ fontSize: "0.8rem" }}
                              >
                                Tên KH <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                id="newCustomerNameOrder"
                                value={newCustomerName}
                                onChange={(e) =>
                                  setNewCustomerName(e.target.value)
                                }
                                required
                                disabled={customerLoading}
                              />
                            </div>
                            <div className="mb-1">
                              <label
                                htmlFor="newCustomerAddressOrder"
                                className="form-label"
                                style={{ fontSize: "0.8rem" }}
                              >
                                Địa Chỉ
                              </label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                id="newCustomerAddressOrder"
                                value={newCustomerAddress}
                                onChange={(e) =>
                                  setNewCustomerAddress(e.target.value)
                                }
                                disabled={customerLoading}
                              />
                            </div>
                            <div className="mb-1">
                              <label
                                htmlFor="newCustomerTaxCodeOrder"
                                className="form-label"
                                style={{ fontSize: "0.8rem" }}
                              >
                                MST
                              </label>
                              <div className="input-group input-group-sm">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="newCustomerTaxCodeOrder"
                                  value={newCustomerTaxCode}
                                  onChange={(e) => {
                                    setNewCustomerTaxCode(e.target.value);
                                    setVerifiedBusinessTaxCode("");
                                  }}
                                  disabled={customerLoading}
                                />
                              </div>
                            </div>
                            <div className="d-flex justify-content-end mt-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => setShowNewCustomerForm(false)}
                                disabled={customerLoading}
                              >
                                Hủy
                              </button>
                              <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                disabled={customerLoading}
                              >
                                {customerLoading ? "Lưu..." : "Lưu"}
                              </button>
                            </div>
                          </form>
                        )}
                      </div>
                      {/* Giảm giá trực tiếp */}
                      <div className="discount-section">
                        <h4
                          style={{
                            fontSize: "1rem",
                            color: "#333",
                            fontWeight: "bold",
                          }}
                        >
                          Giảm giá trực tiếp
                        </h4>
                        <div className="input-group mb-3">
                          <input
                            type="number"
                            min="0"
                            max="100"
                            className="form-control"
                            placeholder="Nhập % giảm giá (0-100)"
                            value={discountCode}
                            onChange={(e) => setDiscountCode(e.target.value)}
                            disabled={isEmployeeCustomer}
                            title={
                              isEmployeeCustomer
                                ? "Khách nhân viên: khóa Giảm giá trực tiếp (%)"
                                : ""
                            }
                          />
                          <span className="input-group-text">%</span>
                          <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={handleApplyDiscount}
                          >
                            Áp dụng
                          </button>
                        </div>
                        {/*{discountPercent > 0 && (
                          <div className="discount-applied">
                            Đã áp dụng giảm giá {discountPercent}%.
                          </div>
                        )}*/}
                      </div>

                      {/* Giảm tiền mặt - Chỉ hiển thị khi LoaiCH = 3 hoặc 99 */}
                      {(localStorage.getItem("LoaiCH") === "3" ||
                        localStorage.getItem("LoaiCH") === "99") && (
                        <div className="discount-section">
                          <h4
                            style={{
                              fontSize: "1rem",
                              color: "#333",
                              fontWeight: "bold",
                            }}
                          >
                            Giảm tiền mặt
                          </h4>
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              min="0"
                              className="form-control"
                              placeholder="Nhập số tiền giảm"
                              value={cashDiscount || ""}
                              onChange={(e) =>
                                setCashDiscount(
                                  Math.max(0, parseInt(e.target.value) || 0),
                                )
                              }
                            />
                            <span className="input-group-text">₫</span>
                            <button
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => {
                                if (cashDiscount > subtotal) {
                                  toast.error(
                                    "Giảm tiền mặt không được lớn hơn tạm tính!",
                                  );
                                  setCashDiscount(0);
                                } else {
                                  toast.success(
                                    `Đã áp dụng giảm ${cashDiscount.toLocaleString()}₫`,
                                  );
                                }
                              }}
                            >
                              Áp dụng
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="voucher-section">
                        <h5
                          style={{
                            fontSize: "1rem",
                            color: "#333",
                            fontWeight: "bold",
                          }}
                        >
                          Nhập mã giảm giá
                        </h5>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nhập mã giảm giá"
                            value={voucherCode}
                            onChange={(e) => { voucherLookupRequest.current += 1; setVoucherCode(e.target.value); setVoucherInfo(null); setVoucherDiscount(0); }}
                          />
                          <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={handleApplyVoucher}
                          >
                            Áp dụng
                          </button>
                        </div>
                        {voucherError && (
                          <div
                            className="text-danger"
                            style={{ fontSize: "0.95em" }}
                          >
                            {voucherError}
                          </div>
                        )}
                        {/*{voucherInfo && (
                          <div
                            className="text-success"
                            style={{ fontSize: "0.95em" }}
                          >
                            Đã áp dụng:{" "}
                            {voucherInfo.TienCK > 0
                              ? `Giảm ${voucherInfo.TienCK.toLocaleString()}₫`
                              : voucherInfo.ChietKhau > 0
                              ? `Giảm ${voucherInfo.ChietKhau}%`
                              : "Không có giảm giá"}
                          </div>
                        )}*/}
                      </div>
                      {/* Thêm trường nhập ghi chú hóa đơn */}
                      <div className="mb-3">
                        <label
                          htmlFor="billNoteInput"
                          style={{
                            fontSize: "1rem",
                            fontWeight: "bold",
                            color: "#333",
                          }}
                        >
                          Ghi chú hóa đơn
                        </label>
                        <textarea
                          id="billNoteInput"
                          className="form-control"
                          rows={2}
                          placeholder="Nhập ghi chú cho hóa đơn (nếu có)..."
                          value={billNote}
                          onChange={(e) => setBillNote(e.target.value)}
                          style={{ fontSize: "1em" }}
                        />
                      </div>
                      {/* Tổng kết hóa đơn không dùng bảng */}
                      <div className="mb-3">
                        <div className="d-flex justify-content-between py-1">
                          <span>
                            <b style={{ color: "green" }}>Tạm tính</b>
                          </span>
                          <span>
                            <b>{subtotal.toLocaleString()}₫</b>
                          </span>
                        </div>
                        {membershipDiscountPercent > 0 && (
                          <div className="d-flex justify-content-between py-1">
                            <span>Giảm giá NV (15%)</span>
                            <span className="text-success">
                              -{membershipDiscountAmount.toLocaleString()}₫
                            </span>
                          </div>
                        )}
                        {discountPercent > 0 && (
                          <div className="d-flex justify-content-between py-1">
                            <span>Giảm giá ({discountPercent}%):</span>
                            <span className="text-success">
                              -{discountAmount.toLocaleString()}₫
                            </span>
                          </div>
                        )}
                        {cashDiscount > 0 && (
                          <div className="d-flex justify-content-between py-1">
                            <span>Giảm tiền mặt:</span>
                            <span className="text-success">
                              -{cashDiscount.toLocaleString()}₫
                            </span>
                          </div>
                        )}
                        {voucherDiscount > 0 && (
                          <div className="d-flex justify-content-between py-1">
                            <span>Voucher</span>
                            <span className="text-success">
                              -{voucherDiscount.toLocaleString()}₫
                            </span>
                          </div>
                        )}
                        {usePointDiscount > 0 && (
                          <div className="d-flex justify-content-between py-1">
                            <span>Trừ điểm tiêu:</span>
                            <span className="text-success">
                              -{usePointDiscount.toLocaleString()}₫
                            </span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between py-2 border-top mt-2">
                          <span>
                            <b style={{ color: "green" }}>Thành tiền</b>
                          </span>
                          <span>
                            <b>{total.toLocaleString()}₫</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer role="group" aria-label="Thao tác thanh toán">
                  <Button variant="secondary" onClick={handleCloseConfirmModal}>
                    Đóng
                  </Button>
                  <Button
                    variant="success"
                    onClick={handleCheckoutSafe}
                    disabled={
                      isProcessing || // ✅ Giữ nguyên logic hiện tại
                      (isGrabFoodyMode
                        ? paymentMethod === null ||
                          (paymentMethod !== "grab" &&
                            paymentMethod !== "shopee")
                        : (paymentMethod === "cash"
                            ? parseInt(cashGiven || "0", 10) < total
                            : paymentMethod === null) ||
                          (localStorage.getItem("LoaiCH") === "0" &&
                            !selectedTable))
                    }
                    style={{
                      pointerEvents: isProcessing ? "none" : "auto", // ✅ Block mọi sự kiện
                    }}
                  >
                    {isProcessing
                      ? "Đang thanh toán..."
                      : "Xác nhận thanh toán"}
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* Modal ghi chú sản phẩm */}
              <Modal
                show={showNoteModal}
                onHide={handleCloseNoteModal}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Ghi chú cho sản phẩm</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {noteModalItem && (
                    <>
                      <div>
                        <strong>{noteModalItem.name}</strong>
                      </div>
                      <div className="mb-3 mt-2">
                        <label className="form-label">Ghi chú</label>
                        <textarea
                          className="form-control"
                          rows={2}
                          value={noteInput}
                          onChange={(e) => setNoteInput(e.target.value)}
                          placeholder="Nhập ghi chú cho sản phẩm này..."
                        />
                      </div>
                      <div className="d-none" style={{ fontSize: "0.9rem" }}>
                        ThÃ nh tiá»n mÃ³n trÆ°á»›c giáº£m:{" "}
                        <strong>
                          {noteModalLineTotal.toLocaleString()}â‚«
                        </strong>
                      </div>
                      <div className="d-none">
                        <label className="form-label">
                          Sá»‘ tiá»n giáº£m giÃ¡ mÃ³n
                        </label>
                        <div style={{ maxWidth: 200 }}>
                          <input
                            type="number"
                            min={0}
                            step="0.01"
                            className="form-control"
                            value={noteDiscountAmountInput}
                            onChange={(e) =>
                              handleNoteDiscountAmountChange(e.target.value)
                            }
                            placeholder="Nháº­p sá»‘ tiá»n giáº£m"
                          />
                        </div>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Số lượng</label>
                        <input
                          type="number"
                          min={1}
                          className="form-control no-spinner"
                          value={noteQtyInput}
                          onChange={(e) =>
                            handleNoteQtyInputChange(e.target.value)
                          }
                          style={{ maxWidth: 120 }}
                        />
                      </div>
                      <div
                        className="mb-2 text-muted"
                        style={{ fontSize: "0.9rem" }}
                      >
                        Thành tiền trước giảm:{" "}
                        <strong>
                          {noteModalLineTotal.toLocaleString()} VND
                        </strong>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">
                          Số tiền giảm giá
                        </label>
                        <div style={{ maxWidth: 200 }}>
                          <input
                            type="number"
                            min={0}
                            step="1"
                            className="form-control"
                            value={noteDiscountAmountInput}
                            onFocus={() => {
                              if (
                                noteDiscountAmountInput === 0 ||
                                noteDiscountAmountInput === "0"
                              ) {
                                handleNoteDiscountAmountChange("");
                              }
                            }}
                            onBlur={() => {
                              if (
                                noteDiscountAmountInput === "" ||
                                noteDiscountAmountInput === null
                              ) {
                                handleNoteDiscountAmountChange(0);
                              }
                            }}
                            onChange={(e) =>
                              handleNoteDiscountAmountChange(e.target.value)
                            }
                            placeholder="Nhap so tien giam"
                          />
                        </div>
                      </div>
                      <div className="mb-2">
                        <label className="form-label">% giảm giá món</label>
                        <div style={{ maxWidth: 160 }}>
                          <input
                            type="number"
                            min={0}
                            max={100}
                            step="1"
                            className="form-control"
                            value={noteDiscountInput}
                            onFocus={() => {
                              if (
                                noteDiscountInput === 0 ||
                                noteDiscountInput === "0"
                              ) {
                                handleNoteDiscountPercentChange("");
                              }
                            }}
                            onBlur={() => {
                              if (
                                noteDiscountInput === "" ||
                                noteDiscountInput === null
                              ) {
                                handleNoteDiscountPercentChange(0);
                              }
                            }}
                            onChange={(e) =>
                              handleNoteDiscountPercentChange(e.target.value)
                            }
                            placeholder="0 - 100"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseNoteModal}>
                    Hủy
                  </Button>
                  <Button variant="primary" onClick={handleSaveNoteModal}>
                    Lưu
                  </Button>
                </Modal.Footer>
              </Modal>

              {orderItems.length === 0 ? (
                <p className="empty-order">
                  Đơn hàng trống. Vui lòng chọn sản phẩm!
                </p>
              ) : (
                <div className="order-items">
                  {orderItems.map((item) => (
                    <div key={item._uniqueId || item.id} className={`order-item${item._addonParent ? " order-addon-item" : ""}`}>
                      <div className="item-info">
                        <h5
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline dotted",
                          }}
                          title="Nhấn để thêm ghi chú"
                          onClick={() => handleOpenNoteModal(item)}
                        >
                          {item.name}
                        </h5>
                        <p className="item-price">
                          {getDiscountedUnitPrice(item).toLocaleString()}₫ x{" "}
                          {item.quantity}
                          {Number(item.KmaiPT) > 0 && (
                            <span
                              style={{
                                marginLeft: 8,
                                color: "#dc3545",
                                fontWeight: 600,
                              }}
                            >
                              (-{Number(item.KmaiPT)}%)
                            </span>
                          )}
                        </p>
                        {isBreadWithFilling(item) && !item._addonParent && (
                          <button type="button" className="btn btn-sm btn-outline-success order-bread-addon-btn"
                            aria-label={`Ăn kèm ${item.name}`} disabled={isProcessing} onClick={() => setAddonItem(item)}>
                            + Ăn kèm
                          </button>
                        )}
                        {getProductLoSX(item) && (
                          <div
                            className="item-note"
                            style={{ fontSize: "0.95em", color: "#555" }}
                          >
                            LoSX: {getProductLoSX(item)}
                          </div>
                        )}
                        {item.note && (
                          <div
                            className="item-note"
                            style={{ fontSize: "0.95em", color: "#555" }}
                          >
                            <i className="fas fa-sticky-note me-1"></i>
                            {item.note}
                          </div>
                        )}
                      </div>
                      <div className="item-controls">
                        <span className="item-total">
                          {getItemLineTotal(item).toLocaleString()}₫
                        </span>
                        <div className="quantity-controls">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() =>
                              handleRemoveFromOrder(item._uniqueId || item.id)
                            }
                          >
                            -
                          </button>
                          <input
                            type="number"
                            className="no-spinner"
                            min="1"
                            step="1"
                            value={item.quantity}
                            onChange={(e) => {
                              const val = normalizeSaleQuantity(e.target.value);
                              setOrderItems((prev) =>
                                prev.map((i) =>
                                  (i._uniqueId || i.id) ===
                                  (item._uniqueId || item.id)
                                    ? { ...i, quantity: val }
                                    : i,
                                ),
                              );
                            }}
                            onWheel={(e) => e.target.blur()}
                            style={{
                              width: 60,
                              height: 30,
                              padding: "2px 4px",
                              textAlign: "center",
                              fontSize: 16,
                              border: "none",
                              textAlignLast: "center",
                            }}
                          />
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => handleAddToOrder(item)}
                            style={{
                              border: "1px solid #198754",
                              marginLeft: "-10px",
                            }}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <OrderGiftDrinkRows items={giftDrinks.giftItems} />
                </div>
              )}

              {/* Phần giảm giá */}
              <div className="discount-section d-md-none">
                <button onClick={handleApplyDiscountPrompt}>
                  Giảm giá trực tiếp
                </button>
                {/* {discountPercent > 0 && (
                  <div className="discount-applied">
                    Đã áp dụng giảm giá {discountPercent}%.
                  </div>
                )}*/}
              </div>
              <div className="order-totals">
                <div className="total-row">
                  <span>Tạm tính:</span>
                  <span>{subtotal.toLocaleString()}₫</span>
                </div>
                {membershipDiscountPercent > 0 && (
                  <div className="total-row discount">
                    <span>Giảm giá NV (15%)</span>
                    <span className="text-success">
                      -{membershipDiscountAmount.toLocaleString()}₫
                    </span>
                  </div>
                )}
                {discountPercent > 0 && (
                  <div className="total-row discount">
                    <span>Giảm giá ({discountPercent}%):</span>
                    <span className="text-success">
                      -{discountAmount.toLocaleString()}₫
                    </span>
                  </div>
                )}
                {voucherDiscount > 0 && (
                  <div className="total-row discount">
                    <span>Voucher</span>
                    <span className="text-success">
                      -{voucherDiscount.toLocaleString()}₫
                    </span>
                  </div>
                )}
                {usePointDiscount > 0 && (
                  <div className="total-row discount">
                    <span>Trừ điểm tiêu ({usePointValue}):</span>
                    <span className="text-success">
                      -{usePointDiscount.toLocaleString()}₫
                    </span>
                  </div>
                )}
                <div className="total-row grand-total">
                  <span>Thành tiền:</span>
                  <span>{total.toLocaleString()}₫</span>
                </div>
              </div>

              <div className="order-actions" role="group" aria-label="Thao tác giỏ hàng">
                <OrderGiftDrinkPicker gifts={giftDrinks} disabled={isProcessing}
                  onCheckout={orderItems.length > 0 ? handleGiftDrinksCheckout : undefined} />
                <button
                  className="btn btn-lg btn-success checkout-btn"
                  style={{ fontSize: "1 rem" }}
                  onClick={handleOpenConfirmModal}
                  disabled={orderItems.length === 0}
                >
                  Thanh toán
                </button>
                <button
                  className="btn btn-lg btn-outline-danger clear-cart-btn"
                  onClick={handleClearCart}
                  disabled={orderItems.length === 0}
                  style={{ marginLeft: 10, fontSize: "1 rem" }}
                >
                  Xóa giỏ hàng
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal giỏ hàng cho mobile */}
      <Modal
        show={showCartModal}
        onHide={() => setShowCartModal(false)}
        centered
        className="d-md-none"
        dialogClassName="mobile-cart-modal"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Giỏ hàng</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="order-summary mobile-order-summary">
            {/* Dùng lại nội dung giỏ hàng hiện có */}
            {/* Modal xác nhận thanh toán & ghi chú đã ở cùng component nên vẫn hoạt động */}
            {orderItems.length === 0 ? (
              <p className="empty-order">
                Đơn hàng trống. Vui lòng chọn sản phẩm!
              </p>
            ) : (
              <>
                <div className="order-items">
                  {orderItems.map((item) => (
                    <div key={item._uniqueId || item.id} className={`order-item${item._addonParent ? " order-addon-item" : ""}`}>
                      <div className="item-info">
                        <h5
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline dotted",
                          }}
                          title="Nhấn để thêm ghi chú"
                          onClick={() => handleOpenNoteModal(item)}
                        >
                          {item.name}
                        </h5>
                        <p className="item-price">
                          {getDiscountedUnitPrice(item).toLocaleString()}₫ x{" "}
                          {item.quantity}
                          {Number(item.KmaiPT) > 0 && (
                            <span
                              style={{
                                marginLeft: 8,
                                color: "#dc3545",
                                fontWeight: 600,
                              }}
                            >
                              (-{Number(item.KmaiPT)}%)
                            </span>
                          )}
                        </p>
                        {isBreadWithFilling(item) && !item._addonParent && (
                          <button type="button" className="btn btn-sm btn-outline-success order-bread-addon-btn"
                            aria-label={`Ăn kèm ${item.name}`} disabled={isProcessing} onClick={() => setAddonItem(item)}>
                            + Ăn kèm
                          </button>
                        )}
                        {getProductLoSX(item) && (
                          <div
                            className="item-note"
                            style={{ fontSize: "0.95em", color: "#555" }}
                          >
                            LoSX: {getProductLoSX(item)}
                          </div>
                        )}
                        {item.note && (
                          <div
                            className="item-note"
                            style={{ fontSize: "0.95em", color: "#555" }}
                          >
                            <i className="fas fa-sticky-note me-1"></i>
                            {item.note}
                          </div>
                        )}
                      </div>
                      <div className="item-controls">
                        <span className="item-total">
                          {getItemLineTotal(item).toLocaleString()}₫
                        </span>
                        <div className="quantity-controls">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() =>
                              handleRemoveFromOrder(item._uniqueId || item.id)
                            }
                          >
                            -
                          </button>
                          <span className="quantity">{item.quantity}</span>
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() => handleAddToOrder(item)}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <OrderGiftDrinkRows items={giftDrinks.giftItems} />
                </div>
                <div className="order-totals">
                  <div className="total-row">
                    <span>Tạm tính:</span>
                    <span>{subtotal.toLocaleString()}₫</span>
                  </div>
                  {discountPercent > 0 && (
                    <div className="total-row discount">
                      <span>Giảm giá ({discountPercent}%):</span>
                      <span>-{discountAmount.toLocaleString()}₫</span>
                    </div>
                  )}
                  {/* Thêm dòng giảm từ voucher nếu có */}
                  {voucherDiscount > 0 && (
                    <div className="total-row discount">
                      <span>Voucher: </span>
                      <span>-{voucherDiscount.toLocaleString()}₫</span>
                    </div>
                  )}
                  {usePointDiscount > 0 && (
                    <div className="total-row discount">
                      <span>Trừ điểm tiêu ({usePointValue}):</span>
                      <span>-{usePointDiscount.toLocaleString()}₫</span>
                    </div>
                  )}
                  <div className="total-row grand-total">
                    <span>Thành tiền:</span>
                    <span>{total.toLocaleString()}₫</span>
                  </div>
                </div>
                {!isGrabFoodyMode && (
                  <div className="mobile-quick-payment mb-2">
                    <div className="mobile-quick-payment-label">
                      Thanh toán nhanh
                    </div>
                    <div className="mobile-quick-payment-methods">
                      <button
                        className={`btn btn-sm ${
                          paymentMethod === "cash"
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => {
                          setPaymentMethod("cash");
                          autofillCashGiven();
                        }}
                        type="button"
                      >
                        Tiền mặt
                      </button>
                      <button
                        className={`btn btn-sm ${
                          paymentMethod === "transfer"
                            ? "btn-primary"
                            : "btn-outline-primary"
                        }`}
                        onClick={() => {
                          setPaymentMethod("transfer");
                          resetCashGiven();
                        }}
                        type="button"
                      >
                        Chuyển khoản
                      </button>
                    </div>
                  </div>
                )}
                <div className="order-actions" role="group" aria-label="Thao tác giỏ hàng mobile">
                  <OrderGiftDrinkPicker gifts={giftDrinks} disabled={isProcessing}
                    onCheckout={orderItems.length > 0 ? handleGiftDrinksCheckout : undefined} />
                  <button
                    className="btn btn-lg btn-success checkout-btn"
                    style={{ fontSize: "1 rem" }}
                    onClick={handleMobileQuickCheckout}
                    disabled={
                      orderItems.length === 0 ||
                      isProcessing ||
                      (isGrabFoodyMode
                        ? true
                        : !["cash", "transfer"].includes(paymentMethod))
                    }
                  >
                    {isProcessing ? "Đang thanh toán..." : "Thanh toán nhanh"}
                  </button>
                  <button
                    className="btn btn-lg btn-outline-primary clear-cart-btn"
                    onClick={handleOpenConfirmModal}
                    disabled={orderItems.length === 0 || isProcessing}
                    style={{ marginLeft: 10, fontSize: "1 rem" }}
                  >
                    Chi tiết thanh toán
                  </button>
                  <button
                    className="btn btn-lg btn-outline-danger clear-cart-btn"
                    onClick={handleClearCart}
                    disabled={orderItems.length === 0}
                    style={{ marginLeft: 10, fontSize: "1 rem" }}
                  >
                    Xóa giỏ hàng
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Nút thanh toán cố định cho màn hình nhỏ */}
      <button
        className="cart-button d-md-none"
        onClick={() => setShowCartModal(true)}
        disabled={orderItems.length === 0}
        style={{
          position: "fixed",
          bottom: 16,
          left: 16,
          right: 16,
          height: 54,
          borderRadius: 14,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "18px",
          fontWeight: 700,
          // Below Bootstrap's modal backdrop (1050) so the cart and checkout
          // modals cover this button instead of the reverse.
          zIndex: 1030,
          border: "none",
          backgroundColor: orderItems.length > 0 ? "#198754" : "#9e9e9e",
          color: "#fff",
        }}
      >
        Thanh toán {orderItems.length > 0 ? `(${orderItems.length})` : ""}
      </button>

      <Modal show={showPrintSettings} onHide={() => setShowPrintSettings(false)} centered
        aria-labelledby="order-print-settings-title" onKeyDown={(event) => event.stopPropagation()}>
        <Modal.Header closeButton>
          <Modal.Title id="order-print-settings-title">Cài đặt in</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="print-toggle-container">
            <input
              type="checkbox"
              id="printToggle"
              checked={isPrintEnabled}
              onChange={handleTogglePrint}
            />
            <label htmlFor="printToggle">In hóa đơn</label>
          </div>
          <div className="print-toggle-container">
            <input
              type="checkbox"
              id="disablePrintAPIToggle"
              checked={isDisablePrintAPI}
              onChange={handleToggleDisablePrintAPI}
            />
            <label htmlFor="disablePrintAPIToggle">Tắt API in</label>
          </div>
          <div className="print-toggle-container" style={{ marginTop: 8 }}>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleOpenPromotionsModal}
            >
              🎁 Xem ưu đãi
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPrintSettings(false)}>Đóng</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default OrderPage;
